$(document).ready(function () {
  var currCountry = Shopify.country;
  var myPassport = [];
  var passportTitle = '';
  const navigationHistory = [];
  const insideNavigationHistory = [];
  var email_pattern = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
  let btn_txt = 'Select passport';
  let selected_btn_txt = 'Selected';
  
  let selectedSize = '';
  let editId = '';

  let checkCustomerAcc = '/apps/GLM/check-customer';
  let addSizePassportUrl = '/apps/GLM/passport-save';
  let getPassportListUrl = '/apps/GLM/get-passports';
  let deletePassportUrl = '/apps/GLM/passport-delete';
  let searchCustomerUrl = '/apps/GLM/customer-list';
  let saveCustomerUrl = '/apps/GLM/save-customer'

  var counter = 0;
  let isJacket = false;
  let isTrousers = false;
  let isUnitInch;

  var hasUid = false;
  var hasMeasurementType = false;
  var globalObj = [];
  var measureObj = [];
  window.media = [];

  let typingTimer;                // Timer identifier
  let doneTypingInterval = 400;  // Time in milliseconds (1 second)

  // Open size drawer when size not selected
  $(document).on("click", ".add_to_cart_btn", function(e){
    e.preventDefault();
    if($(this).parents("form").length > 0){
      $(this).parents("form").find(".sz-ppt-popup-btn").trigger("click");
    }else if($(this).parents(".fix_addtocart").length > 0){
      $(this).parents(".fix_addtocart").find(".sz-ppt-popup-btn, .size-popup-btn").trigger("click");
    }
  });

  $(document).on('click', '.sz-ppt-popup-btn, .open-ppt-drawer', function () {
    $('html, body').animate({ scrollTop: 0 }, 600);
    if($(".sz-ppt-sb-panel").attr("data-customer") != ""){
      if($(".sz-ppt-sb-panel").attr("data-staff-member") == "true"){
        $(".sz-ppt-modifier-multidrawer-slidewrap .sz-ppt-progress-container.isSelected").removeClass("isSelected");
        openMainDrawer();
        $(`.sz-ppt-modifier-multidrawer-slidewrap [data-id="customer-search"]`).addClass('isSelected');
      }else{
        let customerId = $(".sz-ppt-sb-panel").attr("data-customer");
        getSizePassportList(customerId, $(this));
      }
    }else{
      $(".sz-ppt-modifier-multidrawer-slidewrap .sz-ppt-progress-container.isSelected").removeClass("isSelected");
      openMainDrawer();
      $(`.sz-ppt-modifier-multidrawer-slidewrap [drawer-step="1"]`).addClass('isSelected');
    }
  });

  // Open Mix & Match drawer
  $(document).on('click', '.select-mix-match-size-btn', function () {
    $(".sz-ppt-modifier-multidrawer-slidewrap .sz-ppt-progress-container.isSelected").removeClass("isSelected");
    openMainDrawer();
    $(`.sz-ppt-modifier-multidrawer-slidewrap [drawer-step="0"]`).addClass('isSelected');
    $('html, body').animate({ scrollTop: 0 }, 600);
  });

  // Go back for inside & outside drawer
  $(document).on('click', '.sz-ppt-bck-btn', function () {
    if($(this).parents(".inside-selected").length > 0){
      $(this).parents('.inside-selected').attr("drawer-id") == 1 ? goBack($(this)) : insideGoBack($(this));
      $(this).parents('.inside-selected').find(".sz-ppt-validation-msg").remove();

      const dataId = $(this).parents('.inside-selected').attr("data-id");
      if (dataId && dataId.includes("body-measurement")) {
        globalObj = [];
      } 
      measureObj = [];
    }else{
      goBack($(this));
    }
    //console.log('back', measureObj);
  });
  
  $(document).on('click', '.ppt-get-started-btn', function () { changeStep(1, 2); });

  // Jacket garment measurement drawer process
  $(document).on('click', '.sz-ppt-modifier-multidrawer-slidewrap [data-passport="jacket-size-passport"]', function () { changeStep(2, 3); });
  $(document).on('click', '.sz-ppt-modifier-multidrawer-slidewrap [data-passport="create-jacket-size-passport"]', function () { changeStep(12, 3); globalObj = []; measureObj = []; });
  $(document).on('click', '.sz-ppt-modifier-multidrawer-slidewrap [data-passport="continue-jacket-measurement"]', function () { 
    changeStep(3, 7); 
    findInsiders($('#upperBody')); 
  });

  // Jacket body measurement drawer process
  $(document).on('click', '.sz-ppt-modifier-multidrawer-slidewrap [data-passport="continue-jacketbody-measurement"]', function(){ 
    changeStep(3, 11); 
    $(`.sz-ppt-modifier-multidrawer-slidewrap [drawer-step="11"]`).find('.inside-selected .sz-ppt-type-tab').eq(0).addClass('active').siblings(".sz-ppt-type-tab").removeClass("active");
    $(`.sz-ppt-modifier-multidrawer-slidewrap [drawer-step="11"]`).find('.inside-selected .sz-ppt-tabs-Grid').eq(0).addClass('selected').siblings(".sz-ppt-tabs-Grid").removeClass("selected");
    $(`.sz-ppt-modifier-multidrawer-slidewrap [drawer-step="11"]`).find('.inside-selected').find(".sz-ppt-next-btn").removeClass("save-size-passport sz-ppt-login-btn").val("Next");
    findInsiders($(`.sz-ppt-modifier-multidrawer-slidewrap [drawer-step="11"]`).find('#upperBody'));
  });

  // Trousers garment measurement drawer process
  $(document).on('click', '.sz-ppt-modifier-multidrawer-slidewrap [data-passport="trousers-size-passport"]', function () { changeStep(2, 4); });
  $(document).on('click', '.sz-ppt-modifier-multidrawer-slidewrap [data-passport="create-trousers-size-passport"]', function () { changeStep(12, 4); globalObj = []; measureObj = []; });
  $(document).on('click', '.sz-ppt-modifier-multidrawer-slidewrap [data-passport="continue-trousers-measurement"]', function () { changeStep(4, 10); findInsiders($('#lowerBody'));});

  // Trousers body measurement drawer process
  $(document).on('click', '.sz-ppt-modifier-multidrawer-slidewrap [data-passport="continue-trousersbody-measurement"]', function(){ 
    changeStep(4, 13); 
    $(`.sz-ppt-modifier-multidrawer-slidewrap [drawer-step="13"]`).find('.inside-selected .sz-ppt-type-tab').eq(0).addClass('active').siblings(".sz-ppt-type-tab").removeClass("active");
    $(`.sz-ppt-modifier-multidrawer-slidewrap [drawer-step="13"]`).find('.inside-selected .sz-ppt-tabs-Grid').eq(0).addClass('selected').siblings(".sz-ppt-tabs-Grid").removeClass("selected");
    $(`.sz-ppt-modifier-multidrawer-slidewrap [drawer-step="13"]`).find('.inside-selected').find(".sz-ppt-next-btn").removeClass("save-size-passport sz-ppt-login-btn").val("Next");
    findInsiders($(`.sz-ppt-modifier-multidrawer-slidewrap [drawer-step="13"]`).find('#lowerBody'));
  });

  // Waistcoat garment measurement drawer process
  $(document).on('click', '.sz-ppt-modifier-multidrawer-slidewrap [data-passport="waistcoat-size-passport"]', function () { changeStep(2, 15); });
  $(document).on('click', '.sz-ppt-modifier-multidrawer-slidewrap [data-passport="create-waistcoat-size-passport"]', function () { changeStep(12, 15); globalObj = []; measureObj = []; });
  $(document).on('click', '.sz-ppt-modifier-multidrawer-slidewrap [data-passport="continue-waistcoat-measurement"]', function () { changeStep(15, 16); findInsiders($('#waistcoatBody')); });

  // Waistcoat body measurement drawer process
  $(document).on('click', '.sz-ppt-modifier-multidrawer-slidewrap [data-passport="continue-waistcoatbody-measurement"]', function(){ 
    changeStep(15, 17); 
    $(`.sz-ppt-modifier-multidrawer-slidewrap [drawer-step="17"]`).find('.inside-selected .sz-ppt-type-tab').eq(0).addClass('active').siblings(".sz-ppt-type-tab").removeClass("active");
    $(`.sz-ppt-modifier-multidrawer-slidewrap [drawer-step="17"]`).find('.inside-selected .sz-ppt-tabs-Grid').eq(0).addClass('selected').siblings(".sz-ppt-tabs-Grid").removeClass("selected");
    $(`.sz-ppt-modifier-multidrawer-slidewrap [drawer-step="17"]`).find('.inside-selected').find(".sz-ppt-next-btn").removeClass("save-size-passport sz-ppt-login-btn").val("Next");
    findInsiders($(`.sz-ppt-modifier-multidrawer-slidewrap [drawer-step="17"]`).find('#waistcoatBody'));
  });


  // Shirt garment measurement drawer process
  $(document).on('click', '.sz-ppt-modifier-multidrawer-slidewrap [data-passport="shirt-size-passport"]', function () { changeStep(2, 3); });
  $(document).on('click', '.sz-ppt-modifier-multidrawer-slidewrap [data-passport="create-shirt-size-passport"]', function () { changeStep(12, 3); globalObj = []; measureObj = []; });
  $(document).on('click', '.sz-ppt-modifier-multidrawer-slidewrap [data-passport="continue-shirt-measurement"]', function () { changeStep(3, 7); findInsiders($('#upperBody')); });

  // Shirt body measurement drawer process
  $(document).on('click', '.sz-ppt-modifier-multidrawer-slidewrap [data-passport="continue-shirtbody-measurement"]', function(){ 
    changeStep(3, 11); 
    $(`.sz-ppt-modifier-multidrawer-slidewrap [drawer-step="11"]`).find('.inside-selected .sz-ppt-type-tab').eq(0).addClass('active').siblings(".sz-ppt-type-tab").removeClass("active");
    $(`.sz-ppt-modifier-multidrawer-slidewrap [drawer-step="11"]`).find('.inside-selected .sz-ppt-tabs-Grid').eq(0).addClass('selected').siblings(".sz-ppt-tabs-Grid").removeClass("selected");
    $(`.sz-ppt-modifier-multidrawer-slidewrap [drawer-step="11"]`).find('.inside-selected').find(".sz-ppt-next-btn").removeClass("save-size-passport sz-ppt-login-btn").val("Next");
    findInsiders($('#shirtBody'));
  });


  // Coat garment measurement drawer process
  $(document).on('click', '.sz-ppt-modifier-multidrawer-slidewrap [data-passport="coat-size-passport"]', function () { changeStep(2, 3); });
  $(document).on('click', '.sz-ppt-modifier-multidrawer-slidewrap [data-passport="create-coat-passport"]', function () { changeStep(12, 3); globalObj = []; measureObj = []; });
  $(document).on('click', '.sz-ppt-modifier-multidrawer-slidewrap [data-passport="continue-coat-measurement"]', function () { changeStep(3, 7); findInsiders($('#coatBody')); });

  // Coat body measurement drawer process
  $(document).on('click', '.sz-ppt-modifier-multidrawer-slidewrap [data-passport="continue-coatbody-measurement"]', function(){ 
    changeStep(3, 11); 
    $(`.sz-ppt-modifier-multidrawer-slidewrap [drawer-step="11"]`).find('.inside-selected .sz-ppt-type-tab').eq(0).addClass('active').siblings(".sz-ppt-type-tab").removeClass("active");
    $(`.sz-ppt-modifier-multidrawer-slidewrap [drawer-step="11"]`).find('.inside-selected .sz-ppt-tabs-Grid').eq(0).addClass('selected').siblings(".sz-ppt-tabs-Grid").removeClass("selected");
    $(`.sz-ppt-modifier-multidrawer-slidewrap [drawer-step="11"]`).find('.inside-selected').find(".sz-ppt-next-btn").removeClass("save-size-passport sz-ppt-login-btn").val("Next");
    findInsiders($(`.sz-ppt-modifier-multidrawer-slidewrap [drawer-step="11"]`).find('#coatBody'));
  });

  $(document).on("click", ".customer-search .sz-ppt-search-result a", function() {
    changeStep(14, 6); 
  });


  // Select size & Select Fit preference drawer open
  $(document).on('click', '.sz-ppt-inside-container .select-size-btn', function () { 
    if(!$(this).parents(".sz-ppt-progress-container").hasClass("body-measurement")){
      changeStepInside(1, 2, $(this));
    }
  });
  $(document).on('click', '.sz-ppt-inside-container .fit-preference', function () { 
    if($(this).parents(".sz-ppt-progress-container").hasClass("body-measurement") ){
      if(!$(this).parents(".sz-ppt-progress-container").hasClass("sz-ppt-edit-wrapper")){  // fit preference not open in edit drawer
        $(this).parents(".sz-ppt-middle").find(".sz-ppt-type-tabs [data-tab='fitPreference']").trigger("click"); 
      }
    }else{
      changeStepInside(1, 3, $(this));
    }
  });

  $(document).on('click', '.ppt-login-drawer-btn', function () { changeStep(1, 5); });
  
  $(document).on('click', '.sz-ppt-mask', function () { 
    closeMainDrawer();
    $(".sz-ppt-navigation").find(".sz-ppt-progress-container.isBacked").removeClass("isBacked");
  });

  // Mix & Match drawer process
  $(document).on('click', '.sz-ppt-modifier-multidrawer-slidewrap [data-drawer="jacket-size"]', function () { changeStepInside(1, 2, $(this)); });
  $(document).on('click', '.sz-ppt-modifier-multidrawer-slidewrap [data-drawer="trousers-size"]', function () { changeStepInside(1, 3, $(this)); });
  $(document).on('click', '.sz-ppt-modifier-multidrawer-slidewrap [data-drawer="full-suit-size"]', function () { changeStepInside(1, 4, $(this)); });

  // Select size from size drawer
  $(document).on("click", ".select-size-drawer .sz-ppt-size-var-item", function(){
    if($(this).parents(".sz-ppt-progress-container").hasClass("mix-match-size")){
      if($(this).hasClass("active")){
        $(this).removeClass("active");
        $(this).parents(".inside-selected").find(".sz-ppt-footer .ppt-btn").addClass("disabled").val("SELECT SIZE");
      }else{
        $(this).parents(".sz-ppt-size-var-list").find(".sz-ppt-size-var-item.active").removeClass("active");
        $(this).addClass("active");
        $(this).parents(".inside-selected").find(".sz-ppt-footer .ppt-btn.disabled").removeClass("disabled").val("ADD TO BAG");
      }
    }else{
      $(this).parents(".sz-ppt-size-var-list").find(".sz-ppt-size-var-item.active").removeClass("active");
      $(this).addClass("active");
      $(this).parents(".inside-selected").find(".sz-ppt-footer .ppt-btn.disabled").removeClass("disabled");
    }
  });

  $(document).on("click", ".select-size-drawer .fetch-size-btn", function(){
    selectedSize = $(this).parents(".inside-selected").find(".sz-ppt-size-var-item.active").data("val");
    $(this).parents(".isSelected").find('.sz-ppt-size-actions .select-size-btn').addClass("isSelect").html(selectedSize);
    $(this).parents(".inside-selected").find(".sz-ppt-bck-btn").click();
    getGarmentMeasurements($(this));
  });

  $(document).on("click", ".sz-ppt-inside-container .sz-ppt-footer-popup .ppt-size-guide-btn", function(){
    if($(this).parents(".template-product").find(".smartsize-button-text").length > 0){
      $(this).parents(".template-product").find(".smartsize-button-text").click();
    }
  });

  // Select Fit Preference options
  $(document).on("click", ".sz-ppt-inside-container #fit-preference li", function(){
    $(this).addClass("sz-ppt-preference_active").siblings().removeClass("sz-ppt-preference_active");
    $(this).parents(".inside-selected").find(".sz-ppt-footer .ppt-btn.disabled").removeClass("disabled");
  });

  $(document).on("click", ".sz-ppt-inside-container .sz-ppt-footer-popup .fetch-pref-btn", function(){
    let selectedPref = $(this).parents(".inside-selected").find(".sz-ppt-preference_active h4").text();
    $(this).parents(".isSelected").find('.sz-ppt-size-actions .fit-preference').addClass("isSelect").html(selectedPref);
    $(this).parents(".inside-selected").find(".sz-ppt-bck-btn").click();
    getGarmentMeasurements($(this));
  });

  // Open How to measure drawer
  $(document).on('click', '.sz-ppt-inside-container .sz-ppt-size-inpt-ic, .sz-ppt-inside-container .szpt-pre-size-inpt-ic', function () { 
    if($(this).siblings(".sz-ppt-size-inpt-popup").length > 0){
      $(this).parent(".sz-ppt-size-input").addClass("is-edit").removeClass("opacity_cls");
      $(this).parents(".sz-ppt-tabs-Grid").find(".is-edit").removeClass("is-edit");
      $(this).parent(".sz-ppt-size-input").addClass("is-edit");
      
      let pageTitle = $(this).find("span").text();
      let pageHTML = $(this).parent("div, li").find(".sz-ppt-size-inpt-popup .sz-ppt-size-inpt-body").html();
      let inputHTML = $(this).parents(".sz-ppt-size-input").find(".sz-ppt-size-inptbx").html();
      let selectedVal = $(this).parents(".sz-ppt-size-input").find(".outer_box .sz-ppt-size-input-ele:visible").val();
      let measureUnit = $(this).parents(".sz-ppt-tabs-Grid").find("input[type='checkbox']").prop("checked");

      $(this).parents(".isSelected").find('[data-id="how-to-measure"] .sz-ppt-header h3').text(pageTitle);
      $(this).parents(".isSelected").find('[data-id="how-to-measure"]').find(".sz-ppt-how-to-measure").html(pageHTML);
      
      if($(this).parents("#fitPreference").length > 0 && $(this).parent(".sz-ppt-size-input").length == 0){
        $(this).closest(".isSelected").find('[data-id="how-to-measure"] .sz-ppt-footer').hide();
      }else{
        $(this).closest(".isSelected").find('[data-id="how-to-measure"] .sz-ppt-footer').show().find(".sz-ppt-size-inptbx").html(inputHTML);
        if($(this).parents(".sz-ppt-size-input").find('.height').length > 0){
          if(measureUnit == true){
            if($('.height_fit').val() && $('.height_inch').val()){
              let heightFeet = $(this).parents(".sz-ppt-size-input").find('.height_fit').val();
              let heightInch = $(this).parents(".sz-ppt-size-input").find('.height_inch').val();
              $(this).closest(".isSelected").find('[data-id="how-to-measure"] .sz-ppt-footer .sz-ppt-size-inptbx .height_fit').val(heightFeet);
              $(this).closest(".isSelected").find('[data-id="how-to-measure"] .sz-ppt-footer .sz-ppt-size-inptbx .height_inch').val(heightInch);
            }
          }else{
            $(this).closest(".isSelected").find('[data-id="how-to-measure"] .sz-ppt-footer .sz-ppt-size-inptbx .sz-ppt-size-input-ele:visible').val(selectedVal);
          }
        }else{
          $(this).closest(".isSelected").find('[data-id="how-to-measure"] .sz-ppt-footer .sz-ppt-size-inptbx .sz-ppt-size-input-ele:visible').val(selectedVal);
        }
      }
      let nextStep = $(this).closest(".isSelected").find('[data-id="how-to-measure"]').attr("drawer-id");
      changeStepInside(1, nextStep, $(this)); 
    }
  });

  // Apply how to measure button
  $(document).on("click", ".inside-selected[data-id='how-to-measure'] .apply-btn", function(){
    let _this = $(this);
    let newVal = _this.parent(".sz-ppt-apply-size").find(".sz-ppt-size-input-ele:visible").val();
    let measureUnit = _this.parents(".isSelected").find(".sz-ppt-tabs-Grid.selected").find("input[type='checkbox']").prop("checked");
    
    if(_this.parents(".sz-ppt-apply-size").find(".height").length > 0){
      // For height (Feet & Inch)
      if(measureUnit == true){
        if(_this.parent(".sz-ppt-apply-size").find('.height_fit').val() && _this.parent(".sz-ppt-apply-size").find('.height_inch').val()){
          let heightFeet = _this.parent(".sz-ppt-apply-size").find('.height_fit').val();
          let heightInch = _this.parent(".sz-ppt-apply-size").find('.height_inch').val();
          _this.parents(".isSelected").find(".sz-ppt-tabs-Grid.selected").find('.sz-ppt-size-inptbx .height_fit').val(heightFeet);
          _this.parents(".isSelected").find(".sz-ppt-tabs-Grid.selected").find('.sz-ppt-size-inptbx .height_inch').val(heightInch);
        }
      }else{
        _this.parents(".isSelected").find(".sz-ppt-tabs-Grid.selected").find(".is-edit .outer_box .sz-ppt-size-input-ele:visible").val(newVal);
      }
    }else{
      _this.parents(".isSelected").find(".sz-ppt-tabs-Grid.selected").find(".is-edit .outer_box .sz-ppt-size-input-ele:visible").val(newVal);
    }
    _this.parents(".inside-selected").find(".sz-ppt-bck-btn").click();
  });

  $(document).on("click", ".inside-selected .sz-ppt-advanced-options", function(){
    $(this).toggleClass("active opacity_cls");
    $(this).parents(".sz-ppt-middle").find(".adv_opt").toggleClass("active-adv-options");
    let currId = $(this).parents(".sz-ppt-tabs-Grid.selected").attr("id");
    setTimeout(() => {
      findAdvInsiders($("#"+currId)); // or parent container
    }, 100);
  });

  // Convert cm to inch & inch to cm
  $(document).off('change', '.sz-ppt-size-toggle input[type="checkbox"]').on('change', '.sz-ppt-size-toggle input[type="checkbox"]', function () {
    isUnitInch = $(this).prop('checked');
    
    // Synchronize all checkboxes under current drawer (jacket drawer, trousers drawer) but prevent triggering the event again
    $(this).parents(".sz-ppt-inside-container").find('.sz-ppt-size-toggle input[type="checkbox"]').each(function () {
      if ($(this).prop('checked') != isUnitInch) {
        $(this).prop('checked', isUnitInch);
      }
    });
    let inputs = $(this).parents(".sz-ppt-inside-container").find('.sz-ppt-size-unt-inpts .sz-ppt-size-input .sz-ppt-size-input-ele');
      
    inputs.each(function () {
      let _this = $(this);
      if (!_this.hasClass('sz-ppt-dropdwn-ele') && _this.val() !== '' && _this.parents('.sz-ppt-body-height').length == 0) {
        let inputVal = parseFloat(_this.val());
        _this.val(convertTo(inputVal, isUnitInch ? 'in' : 'cm'));

        /* Deviation convert */
        let leftEl = _this.closest(".sz-ppt-size-inptbx").find(".sz-ppt-ip-left");
        let rightEl = _this.closest(".sz-ppt-size-inptbx").find(".sz-ppt-ip-right");

        // Extract & clean
        let leftVal = parseFloat(leftEl.text().replace(/[()+-]/g, ''));
        let rightVal = parseFloat(rightEl.text().replace(/[()+-]/g, ''));

        // Convert + update
        if (!isNaN(leftVal)) {
          let convertedLeft = convertTo(leftVal, isUnitInch ? 'in' : 'cm');
          leftEl.html(`(-${convertedLeft})`);
        }
        if (!isNaN(rightVal)) {
          let convertedRight = convertTo(rightVal, isUnitInch ? 'in' : 'cm');
          rightEl.html(`(+${convertedRight})`);
        }
        /* End Deviation convert */

        if(_this.parents('.sz-ppt-progress-container').hasClass("body-measurement")){
          _this.attr('data-value', convertTo(inputVal, isUnitInch ? 'in' : 'cm'));
        }else{
          _this.attr('data-value', convertTo(parseFloat(_this.attr('data-value')), isUnitInch ? 'in' : 'cm'));
        }
      }

      if (_this.hasClass('sz-ppt-dropdwn-ele')) {
        _this.toggleClass('hide', (_this.hasClass('sz-ppt-dropdown-cm') && isUnitInch) || (_this.hasClass('sz-ppt-dropdown-inch') && !isUnitInch));
      }

      if(_this.hasClass("height")){
        if (isUnitInch) {
          let height = _this.parents(".sz-ppt-inside-container").find('.height').val();
          if(height){
            let { feet, inches } = cmToFeetInches(height);
            _this.parents(".sz-ppt-inside-container").find('.height_fit').val(feet);
            _this.parents(".sz-ppt-inside-container").find('.height_inch').val(inches);
          }
        } else {
          let heightFt = _this.parents(".sz-ppt-inside-container").find('.height_fit').val();
          let heightInch = _this.parents(".sz-ppt-inside-container").find('.height_inch').val()
          if(heightFt && heightInch){
            //_this.val(feetInchesToCm($('.height_fit').val(), $('.height_inch').val()));
            _this.parents(".sz-ppt-inside-container").find('.height').val(feetInchesToCm(heightFt, heightInch));
          }
        }
      }
      _this.closest('.body-measurement-height-in').toggleClass('hide', !isUnitInch);
      _this.closest('.body-measurement-height-cm').toggleClass('hide', isUnitInch);
    });

    // Now validate with the updated values (pass the first visible input as context for navigation)
    const contextForValidation = inputs.filter(':visible').first();
    if (contextForValidation.length > 0) {
      if(!$(this).parents(".sz-ppt-progress-container").hasClass("sz-ppt-edit-wrapper")){
        validateBodyMeasurementValue(contextForValidation);
      }
    }
  });
  
  // Measurement Value Increment
  $(document).on("click", ".sz-ppt-size-iplus", function(){ updateMeasureValue($(this), "plus"); });

  // Measurement Value Decrement
  $(document).on("click", ".sz-ppt-size-iminus", function(){ updateMeasureValue($(this), "minus"); });

  // Verify customer exist or not
  $(document).on('click', '.sz-ppt-progress-container .customer-customer-verify', function () {
    let _this = $(this);
    let inputEmail = $(this).parents(".sz-ppt-middle").find(".sz-ppt-input-field input[type='email']");
    let inputEmailVal = $(this).parents(".sz-ppt-middle").find(".sz-ppt-input-field input[type='email']").val();
    inputEmail.removeClass("empty-field");
    
    if(!inputEmailVal){
      inputEmail.addClass("empty-field").focus();
    }else{
      _this.parent(".progressBarWrap").addClass("line-loading");
      const formdata = new FormData();
      formdata.append("email", encode(inputEmailVal, 29));
      const requestOptions = {
        method: "POST",
        body: formdata
      };
      
      fetch(checkCustomerAcc, requestOptions)
        .then((response) => response.json())
        .then(result => {
          if(result){
            if(result.status == true){
              /* if customer exist */
              _this.parents(".sz-ppt-loginsaved-form").find(".sz-ppt-customer-verify").removeClass("sz-ppt-customer-verify");
            }else{
              /* open register form drawer */
              changeStep(8, 9);
            }
          }
          _this.parent(".progressBarWrap").removeClass("line-loading");
        })
        .catch((error) => console.error(error));
    }
  });

  // If customer exist, verify login
  $(document).on("click", ".sz-ppt-progress-container .customer-login-verify", function(){
    let _this = $(this);
    var loginForm = $(this).parents("form");
    let inputEmail = loginForm.find(".email").val();
    let inputPassword = loginForm.find(".password").val();
    loginForm.find(".empty-field").removeClass("empty-field");
    loginForm.find(".error-msg").show().find("span").text("");

    if(inputEmail == ''){
      loginForm.find(".email").focus().addClass("empty-field");
    }else if(!email_pattern.test(inputEmail)){
      loginForm.find(".email").focus().addClass("empty-field");
      loginForm.find(".error-msg").show().find("span").text("Enter valid email address");
    }else if(inputPassword == ''){
      loginForm.find(".password").focus().addClass("empty-field");
    }else{
      
      var data = {
        'customer[email]': inputEmail,
        'customer[password]': inputPassword,
        form_type: 'customer_login',
        utf8: '✓'
      };

      $.ajax({
        url: '/account/login',
        method: 'POST',
        data: data,
        dataType: 'html',
        beforeSend: function() {
          _this.parent(".progressBarWrap").addClass("line-loading");
        },
        success:function(loginResp){
          if($(loginResp).find(".account__pages").length > 0){
            let custId = $(loginResp).find(".account__pages").find(".cust-id").val();
            _this.parents(".sz-ppt-sb-panel").attr("data-customer", custId);
            _this.parents(".sz-ppt-modifier-multidrawer-slidewrap").find(".sz-ppt-login-btn").removeClass("sz-ppt-login-btn");
            
            if(_this.hasClass("login-drawer-btn") == true){
              getSizePassportList(custId, _this);
            }else{
              //_this.parents(".sz-ppt-modifier-multidrawer-slidewrap").find(".isBacked").find(".sz-ppt-login-btn").removeClass("sz-ppt-login-btn");
              _this.parents(".isSelected").find(".sz-ppt-bck-btn").click();
            }
          }else if($(loginResp).find(".login-page").length > 0){
            loginForm.find(".error-msg").show().find("span").text($(loginResp).find(".login-page").find(".errors ul li").text());
          }
          _this.parent(".progressBarWrap").removeClass("line-loading");
        }
      });
    }
  });

  // If customer not exist create a new customer
  $(document).on("click", ".sz-ppt-progress-container .customer-register", function(){
    let _this = $(this);
    let regForm = $(this).parents("form");
    let inputEmail = regForm.find(".email").val();
    let inputPassword = regForm.find(".password").val();
    let inputFirstName = regForm.find(".first-name").val();
    let inputLastName = regForm.find(".last-name").val();
    let inputTelephone = regForm.find(".telephone").val();
    regForm.find(".empty-field").removeClass("empty-field");
    regForm.find(".error-msg").show().find("span").text("");

    if(inputEmail == ''){
      regForm.find(".email").focus().addClass("empty-field");
    }else if(!email_pattern.test(inputEmail)){
      regForm.find(".email").focus().addClass("empty-field");
      regForm.find(".error-msg").show().find("span").text("Enter valid email address");
    }else if(inputPassword == ''){
      regForm.find(".password").focus().addClass("empty-field");
    }else if(inputPassword.length < 5){
      regForm.find(".password").focus().addClass("empty-field");
      regForm.find(".error-msg").show().find("span").text("Password is too short (minimum is 5 characters)");
    }else if(inputFirstName == ''){
      regForm.find(".first-name").focus().addClass("empty-field");
    }else if(inputLastName == ''){
      regForm.find(".last-name").focus().addClass("empty-field");
    }else{

      let formData = {
        'customer[first_name]': inputFirstName,
        'customer[last_name]': inputLastName,
        'customer[email]': inputEmail,
        'customer[password]': inputPassword,
        'customer[note][phone]': inputTelephone,
        form_type: 'create_customer',
        utf8: '✓'
      };

      $.ajax({
        url: '/account',
        method: 'post',
        data: formData,
        dataType: 'text',
        beforeSend: function() {
          _this.parent(".progressBarWrap").addClass("line-loading");
        },
        success:function(regResp){
          var $response = $(regResp);
          if($response.find('.index-section').length > 0){
            let custId = $response.find(".customer_dropdown").attr("data-customer");
            if(custId){
              _this.parents(".sz-ppt-sb-panel").attr("data-customer", custId);
            }
            _this.parents(".sz-ppt-modifier-multidrawer-slidewrap").find(".sz-ppt-login-btn").removeClass("sz-ppt-login-btn");
            $(`.sz-ppt-modifier-multidrawer-slidewrap [drawer-step="9"]`).removeClass('isSelected');
            $(`.sz-ppt-modifier-multidrawer-slidewrap [drawer-step="7"]`).removeClass('isBacked').addClass('isSelected');
            //changeStep(9, 7);
          }else{
            regForm.find(".error-msg").show().find("span").text($(regResp).find(".registerForm").find(".errors ul li").text());
          }
           _this.parent(".progressBarWrap").removeClass("line-loading");
        }
      });
    }
  });

  $(document).on("click", ".sz-ppt-progress-container[data-id='my-passport-detail'] .select-passport-btn", function(){
    if($(this).hasClass("selected")){
      $(this).removeClass("selected");
      $(this).text(btn_txt);
    }else{
      $(this).parents(".sz-ppt-mybox-wrapper").find(".selected").text(btn_txt).removeClass("selected");
      $(this).addClass("selected");
      $(this).text(selected_btn_txt);
    }
    
    let selectedPass = true;
    $(this).parents(".sz-ppt-middle").find(".sz-ppt-mybox-wrapper").not(".hide").each(function(pptBox) {
      $(this).find(".selected").length == 0 ? selectedPass = false : '';
    });
    selectedPass == true ? $(this).parents(".isSelected").find(".sz-ppt-add-cart .add-to-cart-passport").removeClass("disabled") : 
      $(this).parents(".isSelected").find(".sz-ppt-add-cart .add-to-cart-passport").addClass("disabled");

    if(checkCustomMade()) { 
      let size = $(".sz-ppt-navigation .sz-ppt-progress-container[data-id='my-passport-detail']").find(".sz-ppt-mybox-wrapper").not(".hide").find(".selected").length;

      $(".sz-ppt-progress-container[data-id='my-passport-detail'] .sz-ppt-mybox-wrapper").not(".hide").each(function(index, val) {
        let selPassport = $(this).find(".selected").prev(".sz-ppt-mybox-in").find("h2").text().trim().replaceAll("*", "");
        if(selPassport){
          $(".cm-progress-container[data-progress='checkout'] .cm-main-sizes").find(".cm-modifier-card-container").eq(index).find(".cm-modifier-result-title").text(selPassport);
          $(".cm-progress-container[data-progress='checkout'] .cm-main-sizes").find(".cm-modifier-card-container").eq(index).find(".err-cls").removeClass("err-cls");
        } else {
          $(".cm-progress-container[data-progress='checkout'] .cm-main-sizes").find(".cm-modifier-card-container").eq(index).find(".cm-modifier-result-title").text("Select Passport");
          $(".cm-progress-container[data-progress='checkout'] .cm-main-sizes").find(".cm-modifier-card-container").eq(index).find(".cm-modifier-card-content").addClass("err-cls");
        }
      });
    }
  });

  // Save Passport
  $(document).on('click', '.save-size-passport', function () {
    let finalData = getMeasurements($(this), "save");
    if(finalData){
      savePassport(finalData, $(this));
    }
  });

  // Edit passport
  $(document).on("click", ".ppt_edit_delete .ppt_edit", async function(){
    globalObj = []; measureObj = [];
    let key = $(this).parents(".sz-ppt-mybox").attr("data-key");
    editId = key;
    const items = myPassport.filter(item => item.uid.indexOf(key) !== -1);
    let suggestedTab = false;
    
    if(items){
      let item = items[0];
      globalObj.push(item);

      // Determine fit preference
      const fit = item?.preferences?.fit ?? item?.preferences?.shape ?? 'tailored-fit';

      // Garment types that support a "-body-" variant using a tailored CSV link
      const BODY_VARIANT_TYPES = ['jacket', 'shirt', 'overcoat'];

      // Map garment type keywords to their window data source
      const GARMENT_MAP = {
        'jacket':      window.jacket,
        'trouser':     window.trouser,
        'waistcoat':   window.waistcoat,
        'shirt':       window.shirt,
        'raglan-coat': window.raglan_coat,
        'overcoat':    window.overcoat,
      };

      const garmentKey = Object.keys(GARMENT_MAP).find(key => item.type.includes(key));
      if (garmentKey) {
        const garmentData = GARMENT_MAP[garmentKey];
        const availableKeys = Object.keys(garmentData);

        let csvKey;
        if (availableKeys.length === 1) {
          // Single-option garments (waistcoat, raglan-coat) — fit doesn't apply
          csvKey = availableKeys[0];
        } else if (BODY_VARIANT_TYPES.includes(garmentKey) && item.type.includes('-body-')) {
          // Body variant always uses tailored fit
          csvKey = availableKeys.find(k => k.includes('tailore'));
        } else {
          // Use fit preference
          //csvKey = fit;
          csvKey = availableKeys.find(k => k === fit) ?? availableKeys.find(k => k.includes(fit));
        }

        if(garmentData[csvKey]) {
          const obj = await getBaseSizeMeasurement(item.baseSize, garmentData[csvKey]);
          measureObj.push(obj);
        }
      }
      
      let parentClass = $(".sz-ppt-progress-container[data-id='"+item.type+"']");
      let drawerStep = parentClass.attr("drawer-step");

      if(parentClass.find("#suggestedMeasurements").length > 0){
        parentClass.find("#suggestedMeasurements").addClass("selected").siblings(".sz-ppt-tabs-Grid").removeClass("selected");
      }

      clearPrevMeasureData(parentClass);
      let measureType = parentClass.find("#suggestedMeasurements").length > 0 
        ? parentClass.find("#suggestedMeasurements").find("input[type='checkbox']").prop("checked")
        : parentClass.find(".sz-ppt-size-toggle").find("input[type='checkbox']").prop("checked");

      parentClass.addClass("sz-ppt-edit-wrapper")
      parentClass.find(".sz-passport-name").val(item.passport_name);
      passportTitle = item.passport_name;
      
      parentClass.find(".select-size-btn").addClass("isSelect").text(item.baseSize);
      selectedSize = item.baseSize;
      parentClass.find(".select-size-drawer .sz-ppt-size-var-item[data-val='"+item.baseSize+"']").addClass("active");

      if(item.preferences){
        const preferences_value = Object.values(item.preferences).map(value => value.replaceAll('-', ' ')).join(', ');
        parentClass.find(".fit-preference").addClass("isSelect").text(preferences_value);
        
        if(item.type.includes('body-measurement')) {
        } else {
          parentClass.find(".sz-ppt-inside-container[drawer-id='3'] li[data-title='"+item.preferences.fit.toLowerCase().replaceAll('-', ' ')+"']").addClass("sz-ppt-preference_active");
        }
      }  

      if(currCountry == 'US'){
        if(measureType == false && item.measureUnit == "cm" || measureType == false && item.measureUnit == "inch"){
          parentClass.find("input[type='checkbox']").prop("checked", true);
        }
      }else{
        if(item.measureUnit == 'inch'){
          parentClass.find("input[type='checkbox']").prop("checked", true);
        }else{
          parentClass.find("input[type='checkbox']").prop("checked", false);
        } 
      }
      measureType = parentClass.find("input[type='checkbox']").prop("checked");

      if(parentClass.find("#suggestedMeasurements").length > 0){
        parentClass = parentClass.find("#suggestedMeasurements");
        suggestedTab = true;
      }

      let measurementsArray = Object.entries(item.measurements).map(([key, value]) => ({ ...value }));
      parentClass.find(".sz-ppt-advanced-options").addClass("active").removeClass("opacity_cls");
      parentClass.find(".adv_opt").addClass("active-adv-options");
      
      for(let i=0; i<measurementsArray.length; i++){
        Object.keys(measurementsArray[i]).forEach(function(className, index){

          className = className
            .replace(/(^|-)body(-|$)/, '-')                   // Remove "body"
            .replace(/(^|-)(jacket|trousers|shirt|waistcoat|raglan-coats|overcoats)(-|$)/, '-') // Remove type
            .replace(/^-|-$/g, '')                            // Trim dashes
            .replaceAll("-", "_");

          let currInput = parentClass.find(".sz-ppt-size-inptbx.outer_box").find('.'+className);
          let measureVal = Object.values(measurementsArray[i])[index];

          if(isNaN(measureVal)){
            parentClass.find(".sz-ppt-size-inptbx.outer_box").find("select."+className+".sz-ppt-dropdown-cm").val("standard");
            parentClass.find(".sz-ppt-size-inptbx.outer_box").find("select."+className+".sz-ppt-dropdown-inch").val("standard");
            
            if(currCountry == 'US'){
              parentClass.find(".sz-ppt-size-inptbx.outer_box").find("select."+className+".sz-ppt-dropdown-inch").removeClass("hide");
              parentClass.find(".sz-ppt-size-inptbx.outer_box").find("select."+className+".sz-ppt-dropdown-cm").addClass("hide");
            }else{
              if(item.measureUnit == 'inch'){
                parentClass.find(".outer_box .sz-ppt-size-input-ele.sz-ppt-dropdown-cm").hasClass("hide") ? '' : 
                  parentClass.find(".outer_box .sz-ppt-size-input-ele.sz-ppt-dropdown-cm").addClass("hide");
                parentClass.find(".outer_box .sz-ppt-size-input-ele.sz-ppt-dropdown-inch").hasClass("hide") ?
                  parentClass.find(".outer_box .sz-ppt-size-input-ele.sz-ppt-dropdown-inch").removeClass("hide") : '';
              }else{
                parentClass.find(".outer_box .sz-ppt-size-input-ele.sz-ppt-dropdown-cm").hasClass("hide") ?
                  parentClass.find(".outer_box .sz-ppt-size-input-ele.sz-ppt-dropdown-cm").removeClass("hide") : '';
                parentClass.find(".outer_box .sz-ppt-size-input-ele.sz-ppt-dropdown-inch").hasClass("hide") ? '' : 
                  parentClass.find(".outer_box .sz-ppt-size-input-ele.sz-ppt-dropdown-inch").addClass("hide");
              }
            }
            parentClass.find(".sz-ppt-size-inptbx.outer_box").find("select."+className+" option[value='"+measureVal+"']").prop("selected", true);
          }else{

            /* Deviation calculation */
            let cleanObj = {};
            Object.keys(measureObj[0]).forEach(key => {
              let cleanKey = key.trim();
              cleanObj[cleanKey] = measureObj[0][key];
            });
            let cleanClsName = className.replaceAll("_", " ");
            let baseVal = Number(cleanObj?.[cleanClsName] ?? null);
            /* END Deviation calculation */

            if(currCountry == 'US'){
              var mrvl = measureVal;
              if(item.measureUnit == 'cm'){
                currInput.val(convertTo(measureVal, 'in'));
                currInput.attr("data-value", (measureVal / 2.54).toFixed(2));
                mrvl = convertTo(measureVal, 'in');
              }else{
                currInput.val(measureVal);
                currInput.attr("data-value", measureVal);
              }

              /* Deviation calculation */
              bsvl = convertTo(baseVal, 'in');
              if(baseVal && !isNaN(baseVal)) {
                showDeviation(bsvl, mrvl, 'inch', currInput.closest(".sz-ppt-size-inptbx"));
              }
              /* END Deviation calculation */
            }else{
              currInput.val(measureVal);
              currInput.attr("data-value", measureVal);

              /* Deviation calculation */
              baseVal = item.measureUnit == 'inch' ? convertTo(baseVal, 'in') : baseVal;
              if(baseVal && !isNaN(baseVal)) {
                showDeviation(baseVal, Number(measureVal), item.measureUnit, currInput.closest(".sz-ppt-size-inptbx"));
              }
              /* END Deviation calculation */
            }
          }
          currInput.parents(".sz-ppt-size-input.opacity_cls").removeClass("opacity_cls");
        });
      }
      
      if(suggestedTab) {
        parentClass.closest(".inside-selected").find(".save-as-new-passport, .update-passport").addClass("disabled");
      } else {
        parentClass.find(".save-as-new-passport, .update-passport").addClass("disabled");
      }
      //parentClass.find(".save-as-new-passport, .update-passport").addClass("disabled");
      changeStep(12, drawerStep);
    }
  });

  async function getBaseSizeMeasurement(size, url) {
    const resp = await fetch(url); 
    const size_data = await resp.text();  
    const sizeData = csvToArrayConverter(size_data); 
    const matchRow = sizeData.find(el => el.size.trim() === size.trim());
    return matchRow || null;  
  }

  $(document).on("input", ".sz-passport-name", function(){
    let value = $(this).val();
    if(value == ''){
      $(this).addClass("sz-ppt-empty-title");
      return;
    }else{
      $(this).removeClass("sz-ppt-empty-title");
      if($(this).closest(".sz-ppt-progress-container").hasClass("sz-ppt-edit-wrapper")){
        if(passportTitle != value){
          $(this).parents(".sz-ppt-inside-container").find(".sz-ppt-footer .save-as-new-passport").removeClass("disabled");
          $(this).parents(".sz-ppt-inside-container").find(".sz-ppt-footer .update-passport").removeClass("disabled");
        }else{
          $(this).parents(".sz-ppt-inside-container").find(".sz-ppt-footer .save-as-new-passport").addClass("disabled");
          $(this).parents(".sz-ppt-inside-container").find(".sz-ppt-footer .update-passport").addClass("disabled");
        }
      }
    }
  });

  $(document).on("change click", ".sz-ppt-progress-container.sz-ppt-edit-wrapper", function(event){
    if(event.type == 'click'){
      if ($(event.target).is(".fetch-size-btn, .fetch-pref-btn, .sz-ppt-size-iplus, .sz-ppt-size-iminus")) {
        $(this).find(".sz-ppt-footer .update-passport").removeClass("disabled");
        $(this).find(".sz-ppt-footer .save-as-new-passport").removeClass("disabled");
      }
    }else if(event.type == "change"){
      if(!$(event.target).hasClass("sz-passport-name")){
        $(this).find(".sz-ppt-footer .update-passport").removeClass("disabled");
        $(this).find(".sz-ppt-footer .save-as-new-passport").removeClass("disabled");
      }
    }
  });

  $(document).on("click", ".sz-ppt-progress-container .update-passport, .sz-ppt-progress-container .save-as-new-passport", function(){
    let newArray = getMeasurements($(this), "update");
    //console.log('newArray', newArray);
    if($(this).hasClass("update-passport")){
      newArray != '' ? newArray['editId'] = editId : '';
    } else if($(this).hasClass("save-as-new-passport")){
      newArray != '' ? newArray['copyId'] = editId : '';
    }
    
    if(newArray !== false) {
      savePassport(newArray, $(this));
    }
  });


  // Delete passport
  $(document).on("click", ".ppt_edit_delete .sz-ppt-delete", function(){
    $(this).parents(".sz-ppt-progress-container").find(".alert-notification").addClass("active");
    $(this).parents(".sz-ppt-middle").find(".isDelete").removeClass("isDelete");
    $(this).parents(".sz-ppt-mybox").addClass("isDelete");
  });

  $(document).on("click", ".alert-notification .alert-notification__btn", function(){
    $(this).parents(".alert-notification").removeClass("active");
    let key = $(this).parents(".sz-ppt-progress-container").find(".isDelete").attr("data-key").trim();
    let custId = $(".sz-ppt-sb-panel").attr("data-customer");
    let staffId = '';
    if($(".sz-ppt-sb-panel").attr("data-staff-member") == 'true') {
      staffId = $("body").attr("data-staff-id");
    }
    
    if($(this).hasClass("confirm_btn")){
      $.ajax({
        url: deletePassportUrl,
        type: "POST",
        data: {
          'customer': encode(custId, 32),
          'uid': key,
          'staff_member': staffId
        },
        dataType: 'JSON',
        success: (responseData) => {
          if(responseData.status == true){
            if($(this).parents(".sz-ppt-progress-container").find(".isDelete").find(".select-passport-btn-outline").length > 0){
              $(this).parents(".sz-ppt-progress-container").find(".add-to-cart-passport").addClass("disabled");
            }
            let parentWrapper = $(this).closest(".sz-ppt-progress-container").find(".isDelete").parents(".sz-ppt-mybox-wrapper");
            parentWrapper.find(".delete-msg").html(responseData.message).removeClass("hide");
            setTimeout(function () { parentWrapper.find(".delete-msg").get(0).scrollIntoView({ behavior: 'smooth', block: 'center' }); }, 500);
            $(this).parents(".sz-ppt-progress-container").find(".isDelete").remove();
            setTimeout(function () { parentWrapper.find(".delete-msg").html('').addClass("hide"); }, 3000);
            if($(this).parents(".sz-ppt-progress-container").find(".sz-ppt-mybox").length == 0){
              $(this).parents(".sz-ppt-progress-container").find(".sz-ppt-footer").addClass("hide");
            }else{
              $(this).parents(".sz-ppt-progress-container").find(".sz-ppt-footer").removeClass("hide");
            }
            removeItem(myPassport, key);
            // Remove passport id from the local storage
            window.removePassportFromList(key);
          }
        }
      });
    }else{
      $(this).parents(".sz-ppt-progress-container").find(".isDelete").removeClass("isDelete");
    }
  });

  

  // Add to bag passport
  $(document).on("click", "[data-id='my-passport-detail'] .add-to-cart-passport", function(){
    if(checkCustomMade()) { 
      $(".glm-cm-panel").find(".cm-navigation-bottom .cm-toggle-item.isSelected").next(".cm-toggle-item").trigger("click");
      closeMainDrawer();
      return; 
    } else {
      if($(this).closest("[data-id='my-passport-detail']").find(".sz-ppt-upload-media").length > 0) {
        if($(this).closest("[data-id='my-passport-detail']").find(".sz-ppt-upload-media").hasClass("hide")) {
          $(this).closest("[data-id='my-passport-detail']").find(".sz-ppt-upload-media").removeClass("hide");
          $(this).closest("[data-id='my-passport-detail']").find(".sz-ppt-middle").addClass("hide");
          return;
        } else {
          if($(document).find(".cm-uploaded-media-preview").find(".cm-preview-box").length > 0) {
            if($(document).find(".cm-uploaded-media-preview").find(".cm-preview-box").find(".cm-modifier-remove-btn").not(".hide").length > 0) {
              showMessage('Please upload selected images', 'error');
              return false;
            }
          }
        }
      }
      
      $(this).closest(".sz-ppt-progress-container.isSelected").find(".warning-msg").remove();
      let _this = $(this);
      let varId = $(this).attr("data-variant-id");
      let prop = {};
      let type = $(".product-template__container").attr("data-product-type").toLowerCase().replace(" ", "_") + "_measurement";
      prop['_measurement_type'] = type;

      $(this).parents(".sz-ppt-progress-container").find(".sz-ppt-middle .sz-ppt-mybox-wrapper").each(function(pptBox) {
        let key = "_"+$(this).attr("data-type");
        let passUId = $(this).find(".selected").parents(".sz-ppt-mybox").attr("data-key");

        if(passUId){
          prop[key+'-uid'] = passUId;
          hasUid = true;
        }
        
        // let value = $(this).find(".selected").parents(".sz-ppt-mybox").find(".sz-ppt-mybox-in").attr("data-title");
        // let baseSize = $(this).find(".selected").parents(".sz-ppt-mybox").attr("data-size");
        // let baseSizeKey = key.replace("-passport", "-base-size");
        // prop[key] = value;
        // prop[baseSizeKey] = baseSize;
      });


      var hasValidData = Object.keys(prop).some(function (key) {
        const value = prop[key];
        if (key.includes('-uid') && value) hasUid = true;
        if (key.includes('_measurement_type') && value) hasMeasurementType = true;
        return hasUid && hasMeasurementType;
      });

      // Add uploaded media in properties
      if(window.media.length > 0) {
        prop['_uploaded_media'] = window.media;
      }

      console.log('prop', prop);
      if(hasValidData == true){
        addToBag(varId, 1, prop, _this);
      } else {
        $(this).closest(".sz-ppt-progress-container.isSelected").find(".delete-msg").after('<span class="warning-msg">Please select a passport</span>');
      }
    }
  });

  
  // MIX & MATCH  
  $(document).on("click", ".select-size-drawer .select-mix-match-size", function(){
    let _this = $(this);
    let prop = {};
    let id = $(this).closest(".sz-ppt-inside-container").find(".sz-ppt-size-var-item.active").data("id");
    let type = $(this).closest(".sz-ppt-inside-container").data("id");
    let currSize = $(this).closest(".sz-ppt-inside-container").find(".sz-ppt-size-var-item.active").data("val");

    if(type == "Full Suit") { 
      currSize += " - Full Suit"; 
      prop['_measurement_type'] = 'ready_to_wear';
    }
    
    prop['_Type'] = type;
    prop['_Size'] = currSize;
    addToBag(id, 1, prop, _this);
  });

  $(document).on("click", ".sz-ppt-view-cart-footer .view-cart-btn", function(){ $(".site-header__cart").trigger("click"); });

  
  /************************************** Body Measurement ******************************/
  
  // Tab change
  $(document).on("click", ".sz-ppt-progress-container .sz-ppt-type-tab", function(){
    let activeId = $(this).parent(".sz-ppt-type-tabs").find(".active").data("tab");
    let customerId = $(this).parents(".sz-ppt-sb-panel").attr("data-customer");
    let className = '';
    let inputBox = $(this).parents(".sz-ppt-middle").find("#"+activeId+" .sz-ppt-size-unt-inpts").not(".adv_opt");
    let bodyLength = inputBox.find(".sz-ppt-size-input input.sz-ppt-size-input-ele").length;
    let fitPrefLength = $(this).parents(".sz-ppt-middle").find("#"+activeId+" .szpt-pre-grid").length;

    if($(this).parents(".sz-ppt-middle").find("#"+activeId).find(".sz-ppt-error-msg").text() == ''){
      if(bodyLength > 0){
        for(let i=1; i<=bodyLength; i++){
          if(inputBox.find("input.sz-ppt-size-input-ele").eq(i-1).is(":visible") == true){
            let value = inputBox.find("input.sz-ppt-size-input-ele").eq(i-1).val();
            if(inputBox.find("input.sz-ppt-size-input-ele").eq(i-1).hasClass("height_inch")) {
              if(!value || value < 0){
                inputBox.find("input.sz-ppt-size-input-ele").eq(i-1).focus();
                return false;
              }
            } else {
              if(!value || value <= 0){
                inputBox.find("input.sz-ppt-size-input-ele").eq(i-1).focus();
                return false;
              }
            }
          }
        }
      }else{
        if(activeId == 'fitPreference'){
          if($(this).parents(".sz-ppt-middle").find("#"+activeId+" .szpt-pre-ul-grid .preference_active").length != fitPrefLength){
            return false;
          }
        }
      } 
    }

    // Check the error
    //let err = $(this).parents(".sz-ppt-middle").find(".sz-ppt-tabs-Grid.selected").find(".sz-ppt-field-err").length;
    let err = $(this).parents(".sz-ppt-middle").siblings(".sz-ppt-footer").find(".sz-ppt-field-err").length;
    if(err > 0) {
      return false;
    }
    
    $(this).addClass("active").siblings(".sz-ppt-type-tab").removeClass("active")
    $(this).parents(".sz-ppt-middle").find(".sz-ppt-tabs-Grid.selected").removeClass("selected");
    let targetId = $(this).data("tab");
    $(this).parents(".sz-ppt-middle").find("#"+targetId).addClass("selected");
    
    if($(this).attr("data-tab") == "suggestedMeasurements"){
      let parentWrapper = $(this).parents(".sz-ppt-inside-container");
      let bodyTab = parentWrapper.find('.sz-ppt-tabs-Grid').eq(0);
      let fitPreferenceTab = parentWrapper.find('.sz-ppt-tabs-Grid').eq(1);
      //let suggestedMeasurementsTab = parentWrapper.find('.sz-ppt-tabs-Grid').eq(2);
      let suggestedMeasurementsTab = parentWrapper.find("#suggestedMeasurements");
      let measureUnit = parentWrapper.find("input[type='checkbox']").prop("checked");
      let url = bodyTab.attr("data-link");
      
      if(!customerId){
        className = 'sz-ppt-login-btn save-size-passport'
      }else{
        className = 'save-size-passport'
      }
      
      if($(this).parents(".isSelected").find(".sz-ppt-inside-container[data-id='jacket-body-measurements']").length > 0){
        bodyToGarmentJacketConvertor(parentWrapper, bodyTab, fitPreferenceTab, suggestedMeasurementsTab, measureUnit, url);
      } else if($(this).parents(".isSelected").find(".sz-ppt-inside-container[data-id='trousers-body-measurements']").length > 0){
        let taperedURL = bodyTab.attr("data-link2");
        let wideURL = bodyTab.attr("data-link3");
        let extraWideURL = bodyTab.attr("data-link4");
        bodyToGarmentTrousersConvertor(parentWrapper, bodyTab, fitPreferenceTab, suggestedMeasurementsTab, measureUnit, url, taperedURL, wideURL, extraWideURL);
      } else if($(this).parents(".isSelected").find(".sz-ppt-inside-container[data-id='waistcoat-body-measurements']").length > 0){
        bodyToGarmentWaistcoatConvertor(parentWrapper, bodyTab, '', suggestedMeasurementsTab, measureUnit, url);
      } else if($(this).parents(".isSelected").find(".sz-ppt-inside-container[data-id='shirt-body-measurements']").length > 0){
        bodyToGarmentShirtConvertor(parentWrapper, bodyTab, fitPreferenceTab, suggestedMeasurementsTab, measureUnit, url);
      } else if($(this).parents(".isSelected").find(".sz-ppt-inside-container[data-id='raglan-coat-body-measurements']").length > 0){
        bodyToGarmentRaglanCoatConvertor(parentWrapper, bodyTab, fitPreferenceTab, suggestedMeasurementsTab, measureUnit, url);
      } else if($(this).parents(".isSelected").find(".sz-ppt-inside-container[data-id='overcoat-body-measurements']").length > 0){
        bodyToGarmentOvercoatConvertor(parentWrapper, bodyTab, fitPreferenceTab, suggestedMeasurementsTab, measureUnit, url);
      }
      
      $(this).parents(".sz-ppt-inside-container").find(".sz-ppt-next-btn").addClass(className).val("Save size passport");
    }else{
      $(this).parents(".sz-ppt-inside-container").find(".sz-ppt-next-btn").removeClass('sz-ppt-login-btn save-size-passport save-size-passport').val("Next");
    }
  });

  // Remove opacity class on select & input
  $(document).on("change", ".sz-ppt-dropdwn-ele", function(){ $(this).parents(".sz-ppt-size-input.opacity_cls").removeClass("opacity_cls"); });
  $(document).on("focus", ".input_bx_cls", function(){ $(this).parents(".sz-ppt-size-input.opacity_cls").removeClass("opacity_cls"); });

  // Enable next button
  $(document).on("keyup", ".body-measurement .outer_box .input_bx_cls", function(){
    validateBodyMeasurementValue($(this));
    /*let bodyCounter = 0, err = 0, bodyLength = $(this).parents(".sz-ppt-size-unt-inpts").find(".sz-ppt-size-input input.sz-ppt-size-input-ele").length;
    if(bodyLength > 0){
      
      const isJacket = $context.parents(".inside-selected").attr("data-id") === "jacket-body-measurements";

      for(let i=1; i<=bodyLength; i++){
        if($(this).parents(".sz-ppt-size-unt-inpts").find(".sz-ppt-size-input .outer_box").find("input").eq(i-1).is(":visible") == true){
          let value = $(this).parents(".sz-ppt-size-unt-inpts").find(".sz-ppt-size-input .outer_box").find("input").eq(i-1).val();
          
          if($(this).parents(".sz-ppt-size-unt-inpts").find(".sz-ppt-size-input .outer_box").find("input").eq(i-1).hasClass("height_inch")) {
            value && value > -1 ? bodyCounter+= 1 : '';
          } else {
            value && value > 0 ? bodyCounter+= 1 : '';
          }
        } else { bodyCounter+= 1; }
      }

      if($(this).parents(".inside-selected").attr("data-id") == "jacket-body-measurements") {
        let currUnit = $(this).parents(".sz-ppt-middle").find(".sz-ppt-tabs-Grid.selected").find("input[type='checkbox']").prop("checked") == true ? 'inch' : 'cm';
        checkLmt($(this), currUnit, 'change');
        let err = $(this).parents(".sz-ppt-tabs-Grid.selected").find(".sz-ppt-field-err").length;
        (bodyCounter == bodyLength && err == 0) ? $(this).closest(".sz-ppt-inside-container").find(".sz-ppt-footer .sz-ppt-next-btn").removeClass("disabled") : $(this).closest(".sz-ppt-inside-container").find(".sz-ppt-footer .sz-ppt-next-btn").addClass("disabled");
      } else {
        bodyCounter == bodyLength ? $(this).closest(".sz-ppt-inside-container").find(".sz-ppt-footer .sz-ppt-next-btn").removeClass("disabled") : $(this).closest(".sz-ppt-inside-container").find(".sz-ppt-footer .sz-ppt-next-btn").addClass("disabled");
      }

    }*/
  });


  // Centralized function to validate all body measurements and control Next button
  function validateBodyMeasurementValue($context) {
    let container = $context.closest(".sz-ppt-inside-container");
    let inputsContainer = $context.parents(".sz-ppt-size-unt-inpts");
    let inputs = inputsContainer.find(".sz-ppt-size-input .outer_box input.sz-ppt-size-input-ele");
    let totalInputs = inputs.length;
    let filledCount = 0;
    let hasError = false;

    const isJacket = $context.parents(".inside-selected").attr("data-id") === "jacket-body-measurements";
    const dataId = $context.parents(".inside-selected").attr("data-id");

    const currUnit = isJacket 
      ? ($context.parents(".sz-ppt-middle").find(".sz-ppt-tabs-Grid.selected input[type='checkbox']").prop("checked") ? 'inch' : 'cm')
      : null;

    // Clear previous error messages only for jacket (since only jacket has validation)
    if (isJacket || dataId == "waistcoat-body-measurements" || dataId == "shirt-body-measurements" || dataId == "raglan-coat-body-measurements" || dataId == "overcoat-body-measurements") {
      $context.parents(".inside-selected").find(".sz-ppt-footer").find('.sz-ppt-field-err').remove();
      inputs.removeClass("err-msg-passport");
    }

    inputs.each(function () {
      const inputEle = $(this);
      
      if (!inputEle.is(":visible")) {
        filledCount++;
        return;
      }

      const value = inputEle.val().trim();
      const isHeightInch = inputEle.hasClass("height_inch");
      const isFilled = isHeightInch ? (value !== "" && parseFloat(value) > -1) : (value !== "" && parseFloat(value) > 0);

      if (isFilled) {
        filledCount++;
      }

      // Only validate range for jacket measurements
      if (isJacket && isFilled) {
        const type = (inputEle.attr("name") || "").toLowerCase()
          .replace(/^body-/, "")
          .replace(/-cm$/, "")
          .replace(/-/g, "_");

        // Special handling for height when in inch mode (dual ft/in inputs)
        if (currUnit === 'inch' && type === "height" && Shopify.country == 'US') {
          const $row = inputEle.closest('.sz-ppt-size-input');

          const isFeetInput = inputEle.is($row.find('input.height_fit').first());
          if (!isFeetInput) return;  // Skip the inches input completely

          const $feet = $row.find('input.height_fit');
          const $inch = $row.find('input.height_inch');

          const feet = parseFloat($feet.val()) || 0;
          const inches = parseFloat($inch.val()) || 0;
          const totalInches = feet * 12 + inches;

          const MIN = 55;   // 4'7"
          const MAX = 87;   // 7'3"

          if (totalInches < MIN || totalInches > MAX) {
            hasError = true;
            $feet.addClass("err-msg-passport");
            $inch.addClass("err-msg-passport");

            const display = `${feet}'${inches.toFixed(1).replace(/\.0$/, '')}"`;

            const $error = $(`
              <span class="sz-ppt-msg sz-ppt-error-msg sz-ppt-field-err" data-field="height">
                Height out of range: ${display} (Allowed: 4'7" – 7'3")
              </span>
            `);
            //$row.parents('.sz-ppt-tabs-Grid[id="upperBody"]').prepend($error);
            $row.parents('.inside-selected').find(".sz-ppt-footer").prepend($error);
          } else {
            // Valid → clean up
            $feet.removeClass("err-msg-passport");
            $inch.removeClass("err-msg-passport");
          }
          return; // Skip default validation below
        }

        const ranges = currUnit === 'inch' 
          ? { height: [55.1, 86.6], chest: [27.6, 51.2], shoulders: [14.6, 25.6], upper_waist: [23.6, 55.1], hip: [29.5, 55.1], biceps: [9.8, 19.7], arm_length: [19.7, 29.5] }
          : { height: [140, 220], chest: [70, 130], shoulders: [37, 65], upper_waist: [60, 140], hip: [75, 140], biceps: [25, 50], arm_length: [50, 75] };

        const [min, max] = ranges[type] || [];
        if (min !== undefined) {
          const numVal = parseFloat(value);
          if (numVal < min || numVal > max) {
            hasError = true;
            inputEle.addClass("err-msg-passport");
            
            const fieldName = capitalizeFirstLetter(type.replace(/_/g, " "));
            const $error = $(`
              <span class="sz-ppt-msg sz-ppt-error-msg sz-ppt-field-err" data-field="${type}">
                ${fieldName} out of range: ${numVal} ${currUnit} (Allowed: ${min} ${currUnit} - ${max} ${currUnit})
              </span>
            `);
            //inputEle.parents('.sz-ppt-tabs-Grid[id="upperBody"]').prepend($error);
            inputEle.parents(".inside-selected").find(".sz-ppt-footer").prepend($error);
          }
        }
      }
    });

    /* Validation for the chest and upper waist */
    if(dataId == "jacket-body-measurements" || dataId == "waistcoat-body-measurements" || dataId == "shirt-body-measurements" || dataId == "raglan-coat-body-measurements" || dataId == "overcoat-body-measurements") {
      let chestVal = parseFloat(inputsContainer.find(".chest").val());
      let upperWaistVal = parseFloat(inputsContainer.find(".upper_waist").val());
      if(chestVal && upperWaistVal) {
        if(chestVal < upperWaistVal) {
          hasError = true;
          const $error = $(`<span class="sz-ppt-msg sz-ppt-error-msg sz-ppt-field-err">Chest must be greater than to Upper Waist.</span>`);
          container.find(".sz-ppt-footer").prepend($error);
        } 
      }
    }

    const allFilled = filledCount === totalInputs;
    const canProceed = isJacket ? (allFilled && !hasError) : allFilled;

    container.find(".sz-ppt-footer .sz-ppt-next-btn").toggleClass("disabled", !canProceed);
  }

  // Helper function (make sure it's defined)
  function capitalizeFirstLetter(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
  }

  // Select fit preference
  $(document).on("click", "#fitPreference .szpt-pre-ul-grid li", function(){
    if(!$(this).hasClass("preference_active")){
      $(this).parents("ul").find("li.preference_active").removeClass("preference_active");
    }
    $(this).toggleClass("preference_active");
  });

  // Next button
  $(document).on("click", ".sz-ppt-inside-container .sz-ppt-next-btn", function(){
    $(this).parents(".inside-selected").find(".sz-ppt-middle .selected .sz-ppt-size-actions ").find(".sz-ppt-msg").text('');

    //$(this).parents(".sz-ppt-inside-container").find(".sz-ppt-type-tab.active").next().trigger("click");
    if($(this).parents(".inside-selected").attr("data-id") != 'jacket-body-measurements') {
      // Check the minimum value for Height option
      if($(this).parents(".inside-selected").find(".sz-ppt-middle .selected .height").length > 0){
        let message = '';
        let focusClass = '';
        let heightVal = 0;
        let type = $(this).parents(".inside-selected").find(".sz-ppt-middle .selected").find("input[type='checkbox']").is(":checked");

        if($(this).parents(".inside-selected").find(".sz-ppt-middle .selected .height").is(":visible") == true) {
          heightVal = $(this).parents(".inside-selected").find(".sz-ppt-middle .selected .height").val();
          if(type == true) {
            message = 'Please put height atleast 63 inch';
            heightVal = convertTo(heightVal, 'cm');
          } else {
            message = 'Please put height atleast 160 cm';
          }
          focusClass = '.height';
        }else {
          let heightValFt = $(this).parents(".inside-selected").find(".sz-ppt-middle .selected .height_fit").val();
          let heightValInch = $(this).parents(".inside-selected").find(".sz-ppt-middle .selected .height_inch").val();
          message = 'Please put height atleast 5 feet 3 inches';
          heightVal = feetInchesToCm(heightValFt, heightValInch);
          focusClass = '.height_fit, .height_inch';
        }

        if(heightVal > 0 && heightVal < 160) {
          $(this).parents(".inside-selected").find(".sz-ppt-middle .selected .sz-ppt-size-actions .sz-ppt-msg").text(message);
          $(this).parents(".inside-selected").find(".sz-ppt-middle .selected "+focusClass).focus();
          $(this).parents(".inside-selected").find(".sz-ppt-middle").scrollTop(0);
        } else {
          $(this).parents(".sz-ppt-inside-container").find(".sz-ppt-type-tab.active").next().trigger("click");
        }
      } else {
        $(this).parents(".sz-ppt-inside-container").find(".sz-ppt-type-tab.active").next().trigger("click");
      }
    } else {
      $(this).parents(".sz-ppt-inside-container").find(".sz-ppt-type-tab.active").next().trigger("click");
    }
  });

  
  // Customer search (Only for staff members)
  $(document).on("keyup", "#sz-ppt-customer-search-input", function(){
    clearTimeout(typingTimer);
    let value = $(this).val().trim();
    let $result = $(".customer-search .customer-search-result");
    $result.html('');

    typingTimer = setTimeout(() => {
      if(value){
        $.ajax({
          url: searchCustomerUrl,
          type: "POST",
          data: {'search': value},
          dataType: 'JSON',
          success: function(customers) {
            if(customers){
              if(customers.data && customers.data.length > 0){
                let $html = '';
                for(let i=0; i<customers.data.length; i++){
                  $html+= '<li data-customer-id="'+decode(customers.data[i]['customer_id'], 39)+'">';
                  $html+= '<span class="name">'+customers.data[i]['displayName']+'</span><span class="email">'+customers.data[i]['email']+'</span>';
                  $html+= '</li>';
                }
                $result.html($html);
              }else{
                $result.html('<p>Customer not found. <a>Create a new one?</a></p>');
              }
            }
          }
        });
      }
    }, doneTypingInterval);
  });

  $(document).on("keydown", "#sz-ppt-customer-search-input", function(){
    clearTimeout(typingTimer);
  });

  // Create customer using staff member account (From the customer search drawer)
  $(document).on('click', '.sz-ppt-create-cust-form .create-new-customer', function () {
    let currForm = $(this).parents("form");
    var firstName = currForm.find('.create-cust-first-name').val().trim();
    var lastName  = currForm.find('.create-cust-last-name').val().trim();
    var email     = currForm.find('.create-cust-email').val().trim();
    currForm.find(".empty-field").removeClass("empty-field");
    currForm.find(".error-msg, .success-msg").show().find("span").text("");

    if(firstName == ''){
      currForm.find(".create-cust-first-name").focus().addClass("empty-field");
    } else if(lastName == '') {
      currForm.find(".create-cust-last-name").focus().addClass("empty-field");
    } else if(email == ''){
      currForm.find(".create-cust-email").focus().addClass("empty-field");
    }else if(!email_pattern.test(email)){
      currForm.find(".create-cust-email").focus().addClass("empty-field");
      currForm.find(".error-msg").show().find("span").text("Please enter a valid email address.");
    } else {
      var formData = new FormData();
      formData.append('firstName', firstName);
      formData.append('lastName', lastName);
      formData.append('email', email);

      $.ajax({
        url: saveCustomerUrl,
        type: 'POST',
        data: formData,
        processData: false,
        contentType: false,
        dataType: 'json',
        beforeSend: function() { currForm.find(".progressBarWrap").addClass("line-loading"); },
        success: function (response) {
          currForm.find(".progressBarWrap").removeClass("line-loading");
          if(response.status == true) {
            currForm.find(".success-msg").show().find("span").text(response.message);
            currForm[0].reset();
            setTimeout(() => { $("#sz-ppt-customer-search-input").val(email); }, 500);
          } else {
            currForm.find(".error-msg").show().find("span").text(response.message);
          }
        },
        error: function () {
          currForm.find(".progressBarWrap").removeClass("line-loading");
          currForm.find('.error-msg').show().find("span").text('Something went wrong. Please try again.');
        }
      });
    }
  });

  $(document).on("click", ".customer-search-result li", function(){
    let custId = $(this).attr("data-customer-id");
    let name = $(this).find(".name").text();
    let email = $(this).find(".email").text();
    if(custId){
      $(".sz-ppt-sb-panel").attr("data-customer", custId);
      const customerData = {
        name: name,
        email: email,
        id: custId
      };
      setCookie("customer", customerData, 1); // Sets the object as a cookie named "user" for 2 hours
      getSizePassportList(custId, $(this));
    }
  });

  function setCookie(name, obj, time) {
    let expires = "";
    if (time) {
      //expires = "; max-age=" + time;
      const maxAgeSeconds = time * 24 * 60 * 60;
      expires = "; max-age=" + maxAgeSeconds;
    }
    let encrtData = encode(JSON.stringify(obj), 15);
    document.cookie = name + "=" + encrtData + expires + "; path=/; secure; SameSite=Strict";
  }
  
  
  // Open outer drawer
  function changeStep(currentStep, nextStep) {
    $(`.sz-ppt-modifier-multidrawer-slidewrap [drawer-step="${currentStep}"]`).removeClass('isSelected').addClass('isBacked');
    $(`.sz-ppt-modifier-multidrawer-slidewrap [drawer-step="${nextStep}"]`).addClass('isSelected');
    navigationHistory.push(currentStep);
    if(nextStep == 7 || nextStep == 10 || nextStep == 11 || nextStep == 13){
      if($(`.sz-ppt-modifier-multidrawer-slidewrap [drawer-step="${nextStep}"]`).hasClass("sz-ppt-edit-wrapper") == false){
        let thisObj = $(`.sz-ppt-modifier-multidrawer-slidewrap [drawer-step="${nextStep}"]`);
        if(nextStep != 11 && nextStep != 7 && nextStep != 13 && nextStep != 10) {
          clearPrevMeasureData(thisObj);
        }
      }
    }
  }

  // Open inside drawer
  function changeStepInside(currentStep, nextStep, this_obj) {
    this_obj.parents(".isSelected").find(".inside-selected").removeClass("inside-selected").addClass('isBacked');
    this_obj.parents(".isSelected").find(`[drawer-id="${nextStep}"]`).addClass('inside-selected');
    insideNavigationHistory.push(currentStep);
  }

  // custom made page checking
  function checkCustomMade() {
    return $("html").hasClass("custom-made-suit");
  }


  // Go back from outer drawer
  function goBack(currObj) {
    const previousStep = navigationHistory.pop();
    const currentStep = $('[drawer-step].isSelected').attr('drawer-step');
    const currenBacked = $('.isBacked').length;
    if(currenBacked == 0 || !previousStep){
      $("body").removeClass("sz-ppt-open");
      $('html').removeClass("size-ppt-pop-open");
      if(checkCustomMade() == true){
        $(".glm-cm-panel").find(".cm-navigation-bottom .cm-toggle-item.isSelected").prev(".cm-toggle-item").trigger("click");
      }
    }else{
      $(`.sz-ppt-modifier-multidrawer-slidewrap [drawer-step="${previousStep}"]`).removeClass('isBacked').addClass('isSelected');
    }
    $(`.sz-ppt-modifier-multidrawer-slidewrap [drawer-step="${currentStep}"]`).removeClass('isSelected');
    if($(`.sz-ppt-modifier-multidrawer-slidewrap [drawer-step="${currentStep}"]`).hasClass("sz-ppt-edit-wrapper")){
      $(`.sz-ppt-modifier-multidrawer-slidewrap [drawer-step="${currentStep}"]`).removeClass("sz-ppt-edit-wrapper");
    }
  }

  // Go back from inside drawer
  function insideGoBack(varThis) {
    const previousStep = insideNavigationHistory.pop();
    const currentStep = varThis.parents(".sz-ppt-progress-container").find('[drawer-id].inside-selected').attr('drawer-id');
    if (previousStep !== undefined) {
      varThis.parents(".sz-ppt-progress-container").find(`[drawer-id="${currentStep}"]`).removeClass('inside-selected');
      varThis.parents(".sz-ppt-progress-container").find(`[drawer-id="${previousStep}"]`).removeClass('isBacked').addClass('inside-selected');
    }else if(currentStep == 1){
      $("body").removeClass("sz-ppt-open");
      $('html').removeClass("size-ppt-pop-open");
    }
    if(varThis.parents(".sz-ppt-inside-container").find(".error-msg").length > 0){
      varThis.parents(".sz-ppt-inside-container").find(".error-msg").text('');
    }
  }

  // Increase or Descrease measurement value
  function updateMeasureValue(thisObj, action) {
    let currMeasureType;
    let isHeight = false;
    
    let parentClass = thisObj.parents(".sz-ppt-size-inptbx");
    if(thisObj.parent(".sz-ppt-body-height").length > 0){
      parentClass = thisObj.parent(".sz-ppt-body-height"); // for body measurement
      isHeight = true;
    }
    
    thisObj.parents(".sz-ppt-size-input").hasClass("opacity_cls") ? thisObj.parents(".sz-ppt-size-input").removeClass("opacity_cls") : '';
    let currVal = parentClass.find("input[type='number']").val(),
          realVal = parseFloat(parentClass.find("input[type='number']").attr("data-value")),
          maxLimit = parseFloat(parentClass.find("input[type='number']").attr("max")),
          minLimit = parseFloat(parentClass.find("input[type='number']").attr("min"));
    var new_val, step, limitVal;
    
    if(thisObj.parents(".isSelected").hasClass("body-measurement")){   // for body measurement
      if(thisObj.parents(".sz-ppt-inside-container").attr("data-id") == 'how-to-measure'){
        currMeasureType = thisObj.parents(".body-measurement").find(".sz-ppt-tabs-Grid.selected").find("input[type='checkbox']").prop("checked") == true ? 'inch' : 'cm';
      }else{
        currMeasureType = thisObj.parents(".sz-ppt-tabs-Grid").find("input[type='checkbox']").prop("checked") == true ? 'inch' : 'cm';
      }
    }else{
      currMeasureType = thisObj.parents(".isSelected").find(".sz-ppt-middle input[type='checkbox']").prop("checked") == true ? 'inch' : 'cm';
    }

    step = currMeasureType == 'inch' ? thisObj.parents(".sz-ppt-sb-panel").data("step-inch") : thisObj.parents(".sz-ppt-sb-panel").data("step-cm");
    
    if(currVal){
      let validLimit = false;

      if(action == 'plus'){
        if(currMeasureType == 'inch'){
          step = isHeight == true ? 1 : step;
          new_val = ((parseFloat(currVal)+parseFloat(step)).toFixed(1))*1;
          maxLimit = maxLimit ? parseFloat(convertTo(maxLimit, 'in')) : '';
        }else{
          new_val = parseFloat(currVal)+parseFloat(step);
        }

        if(maxLimit){
          //new_val <= realVal+maxLimit ? parentClass.find("input").val(new_val) : '';
          if(new_val <= realVal+maxLimit) {
            parentClass.find("input").val(new_val);
            validLimit = true;
          }
        }else{
          if(parentClass.find("input").hasClass("height_inch")){
            new_val < 12 ? parentClass.find("input").val(new_val) : '';
          }else{
            parentClass.find("input").val(new_val);
            validLimit = true;
          }
        }
      }else{
        if(currMeasureType == 'inch'){
          step = isHeight == true ? 1 : step;
          new_val = (parseFloat(currVal-parseFloat(step)).toFixed(1))*1;
          minLimit = minLimit ? parseFloat(convertTo(minLimit, 'in')) : '';
          limitVal = (parseFloat(realVal-minLimit).toFixed(1))*1;
        }else{
          new_val = (parseFloat(currVal-parseFloat(step)))*1;
          limitVal = realVal-minLimit;
        }

        if(minLimit){
          //new_val >= limitVal ? parentClass.find("input").val(new_val) : '';
          if(new_val >= limitVal) {
            parentClass.find("input").val(new_val);
            validLimit = true;
          }
        }else{
          //new_val > 0 ? parentClass.find("input").val(new_val) : '';
          if(new_val > 0) {
            parentClass.find("input").val(new_val);
            validLimit = true;
          }
        }
      }

      /* Deviation calculation */
      if(validLimit == true) {

        if(thisObj.parents(".isSelected").attr("data-id").includes("-body-")) {
          if(thisObj.parents("#suggestedMeasurements").length == 0) {
            return;
          }
        }
        
        parentClass.find('.sz-ppt-ip-right, .sz-ppt-ip-left').remove();
        let currInptName = parentClass.find("input").attr("name").replaceAll("_", " ");
        if (measureObj[0] && Object.keys(measureObj[0]).length > 0) {
          let cleanObj = {};
          Object.keys(measureObj[0]).forEach(key => {
            let cleanKey = key.trim().replaceAll("_", " ");
            cleanObj[cleanKey] = measureObj[0][key];
          });
          
          let baseValue = Number(cleanObj?.[currInptName] ?? null);
          if(currMeasureType == 'inch'){
            baseValue = convertTo(baseValue, 'in');
          }
          if(baseValue && !isNaN(baseValue)) {
            showDeviation(baseValue, new_val, currMeasureType, parentClass);
          }
        }
      }
      /* END Deviation calculation */
    }

    if(!thisObj.parents(".sz-ppt-progress-container").hasClass("sz-ppt-edit-wrapper")){
      validateBodyMeasurementValue(thisObj);
    }
    //checkLmt(parentClass.find("input[type='number']"), currMeasureType, 'plus-minus');
  }

  // Get garment measurements from .csv file
  function getGarmentMeasurements(thisObj){
    if(thisObj.parents(".sz-ppt-progress-container").hasClass("waistcoat_garment_measurement")){
      var activeFit = thisObj.parents(".sz-ppt-inside-container").find(".sz-ppt-tabs-Grid");
    }else{
      //var activeFit = thisObj.parents(".isSelected").find(".sz-ppt-inside-container li.sz-ppt-preference_active").length > 0 ? thisObj.parents(".isSelected").find(".sz-ppt-inside-container li.sz-ppt-preference_active") : thisObj.parents(".sz-ppt-inside-container").find(".sz-ppt-tabs-Grid");

      var $selected = thisObj.parents(".isSelected");
      var $activeElements = $selected.find(".sz-ppt-inside-container li.sz-ppt-preference_active");
      var activeFit = $activeElements.length > 0  ? $activeElements : $selected.find(".sz-ppt-inside-container .sz-ppt-tabs-Grid");
    }
    var activeSize = thisObj.parents(".isSelected").find(".sz-ppt-inside-container .sz-ppt-size-var-item.active");
    
    if(activeFit.length > 0 && activeSize.length > 0){
      var activeMeasureType = thisObj.parents(".isSelected").find('.sz-ppt-inside-container input[type="checkbox"]').prop("checked") == true ? 'inch' : 'cm';
      var activeLink = activeFit.data("link");

      if(activeLink){
        fetch(activeLink)
        .then(resp_data => resp_data.text())
        .then(size_data => {
          const sizeData = csvToArrayConverter(size_data);
          const matchRow = sizeData.filter(el => el.size.trim() === activeSize.data("val").trim())[0];

          if(matchRow){
            measureObj.push(matchRow);
            $.each(matchRow, function(key, value){
              var lowerCase = key.toLowerCase().trim().replaceAll(" ", "_").replaceAll("(", "").replaceAll(")", "");
              if(value != ''){
                thisObj.parents(".isSelected").find(".inside-selected .selected").find(".sz-ppt-ip-left, .sz-ppt-ip-right").remove(); // For the deviation
                thisObj.parents(".isSelected").find(".inside-selected .selected").find(".sz-ppt-size-input").each(function(){
                  if(isNaN(value)){
                    $(this).find("select."+lowerCase+" option[value='"+value+"']").prop("selected", true);
                  }else{
                    if(activeMeasureType == 'inch'){
                      $(this).find("."+lowerCase).val(convertTo(value, 'in'));
                      $(this).find("."+lowerCase).attr("data-value", convertTo(value, 'in'));
                    }else{
                      $(this).find("."+lowerCase).val(parseFloat(value));
                      $(this).find("."+lowerCase).attr("data-value", value);
                    }
                  }
                  $(this).removeClass("opacity_cls");
                });
              }else{ }
            });
            thisObj.parents(".isSelected").find('[drawer-id="1"] .sz-ppt-footer .save-size-passport').removeClass("disabled");
          }
        });
      }
    }
  }


  // Save new passport
  function savePassport(valuesObject, _this){
    _this.parents(".sz-ppt-inside-container").find(".sz-ppt-msg").removeClass("sz-ppt-success-msg").removeClass("sz-ppt-error-msg").text('');
    let customerId = $(".sz-ppt-sb-panel").attr("data-customer");
    
    $.ajax({
      url: addSizePassportUrl,
      type: "POST",
      data: {
        'customer': encode(customerId, 20),
        'measurements': valuesObject,
      },
      dataType: 'JSON',
      beforeSend: function() {
        _this.parent(".progressBarWrap").addClass("line-loading");
      },
      success: function (response) {
        _this.parent(".progressBarWrap").removeClass("line-loading");
        if(response){
          if(response.status == true){
            if(_this.parents(".sz-ppt-progress-container").hasClass("sz-ppt-edit-wrapper")){
              // Edit data
              _this.parents(".sz-ppt-inside-container").find(".save-as-new-passport").addClass("disabled");
              _this.parents(".sz-ppt-inside-container").find(".update-passport").addClass("disabled");
              _this.closest(".sz-ppt-progress-container").removeClass("sz-ppt-edit-wrapper");
            }else{
              _this.addClass("disabled");
            }
            clearPrevMeasureData(_this.parents(".sz-ppt-progress-container"));
            //clearPrevMeasureData(_this.parents(".sz-ppt-inside-container"));
            getSizePassportList(customerId, _this);
          }else{
            _this.parents(".sz-ppt-inside-container").find(".save-passport-name .sz-ppt-msg").addClass("sz-ppt-error-msg").text(response.message);
            _this.parents(".sz-ppt-inside-container").find(".save-passport-name .sz-ppt-msg").get(0).scrollIntoView({ behavior: 'smooth', block: 'center' });
            setTimeout(() => {
              _this.parents(".sz-ppt-inside-container").find(".save-passport-name .sz-ppt-msg").removeClass("sz-ppt-error-msg").text('');
            }, 4000);
          }
        }
      }
    });
  }

  // Get passport list
  window.getSizePassportList = function(userId, thisObj){
    let _this = thisObj;
    $.ajax({
      url: getPassportListUrl,
      type: "POST",
      data: {
        'customer': encode(userId, 39)
      },
      dataType: 'JSON',
      beforeSend: function() {
        _this.parent(".progressBarWrap").addClass("line-loading");
      },
      success: function (responseList) {
        if(responseList){
          if(responseList.status == "false"){
            if(_this.parents(".customer-search").length > 0){
              //Go back in search drawer (when staff member logged in)
              let step = _this.parents(".sz-ppt-progress-container").attr("drawer-step");
              let targetstep = $(`.sz-ppt-modifier-multidrawer-slidewrap [data-id="create-passport"]`).attr("drawer-step");
              changeStep(step, targetstep);
            } else{
              $(`.sz-ppt-modifier-multidrawer-slidewrap`).find(".isSelected").removeClass('isSelected');
              $(`.sz-ppt-modifier-multidrawer-slidewrap`).find(".isBacked").removeClass('isBacked');
              $(`.sz-ppt-modifier-multidrawer-slidewrap [drawer-step="2"]`).addClass('isSelected');
              $(`.sz-ppt-modifier-multidrawer-slidewrap [drawer-step="2"]`).find(".sz-ppt-footer").addClass("hide");
            }
            openMainDrawer();
            localStorage.setItem('passport_list', '[]');
          }else{
            showSavedPassport(responseList, _this);
          }
          _this.parent(".progressBarWrap").removeClass("line-loading");
        }
      }
    });
  }

  // Show list of passport 
  window.findData = false;
  window.showSavedPassport = function(passports, thisObj){
    let _this = thisObj;
    let counter = 0;
    let typeVal = $(".product-template__container").data("product-type") || $(".custom-made-suit .sz-ppt-sb-panel").data("type");
    let type = typeVal.toLowerCase();
    
    myPassport = [];
    $(`.sz-ppt-modifier-multidrawer-slidewrap [drawer-step="12"]`).find(".sz-ppt-middle").html('');
    if(passports.data){
      if(type == 'jackets' || type == 'suits' || type == 'tuxedo jackets' || type == 'tuxedo suits'){
        var jacketHTML = '';
        jacketHTML+= '<div class="sz-ppt-mybox-wrapper" data-type="jacket-passport">';
        jacketHTML+= '<h2>JACKET SIZE PASSPORTS</h2><span class="delete-msg hide"></span>';
      
        if(passports.data.jacket && passports.data.jacket.length > 0){
          let jacketPassport = passports.data.jacket;
          for(let i=0; i<jacketPassport.length; i++){
            jacketHTML+= '<div class="sz-ppt-mybox" data-key="'+jacketPassport[i]['uid']+'" data-userid="'+decode(passports.data.user_id, 11)+'" data-size="'+jacketPassport[i]['baseSize']+'">';
            jacketHTML+= '<div class="sz-ppt-mybox-in" data-title="'+jacketPassport[i]['passport_name']+'"><h2>*'+jacketPassport[i]['passport_name']+'*</h2>';
            jacketHTML+= '<p>BASE SIZE:</p><p>'+jacketPassport[i]['baseSize']+'</p>';
            jacketHTML+= '<div class="ppt_edit_delete">';
            jacketHTML+= '<div class="ppt_edit"><a href="javascript:void(0)" class="ppt-link-btn">EDIT</a></div>';
            jacketHTML+= '<div class="ppt_delete"><a href="javascript:void(0)" class="ppt-link-btn sz-ppt-delete">DELETE</a></div>';
            jacketHTML+= '</div></div>';
            jacketHTML+= '<a href="javascript:void(0)" class="select-passport-btn-outline select-passport-btn">'+btn_txt+'</a>';
            jacketHTML+= '</div>';
            myPassport.push(jacketPassport[i]);
          }
          counter+= 1;
        }
        jacketHTML+= '<input type="button" class="ppt-outline-btn full-btn" value="+ CREATE NEW PASSPORT" data-passport="create-jacket-size-passport">';
        jacketHTML+= '</div>';
        $(`.sz-ppt-modifier-multidrawer-slidewrap [drawer-step="12"]`).find(".sz-ppt-middle").append(jacketHTML);
        if(checkCustomMade() == true){
          $("body").removeClass("size-line-loading");
        }
      }

      if(type == 'trousers' || type == 'suits' || type == 'tuxedo trousers' || type == 'tuxedo suits'){
        var trousersHTML = '';
        trousersHTML+= '<div class="sz-ppt-mybox-wrapper" data-type="trousers-passport">';
        trousersHTML+= '<h2>TROUSERS SIZE PASSPORTS</h2><span class="delete-msg hide"></span>';
      
        if(passports.data.trousers && passports.data.trousers.length > 0){
          let trouserPassport = passports.data.trousers;
          for(let i=0; i<trouserPassport.length; i++){
            trousersHTML+= '<div class="sz-ppt-mybox" data-key="'+trouserPassport[i]['uid']+'" data-userid="'+decode(passports.data.user_id, 11)+'" data-size="'+trouserPassport[i]['baseSize']+'">';
            trousersHTML+= '<div class="sz-ppt-mybox-in" data-title="'+trouserPassport[i]['passport_name']+'"><h2>*'+trouserPassport[i]['passport_name']+'*</h2>';
            trousersHTML+= '<p>BASE SIZE:</p><p>'+trouserPassport[i]['baseSize']+'</p>';
            trousersHTML+= '<div class="ppt_edit_delete">';
            trousersHTML+= '<div class="ppt_edit"><a href="javascript:void(0)" class="ppt-link-btn">EDIT</a></div>';
            trousersHTML+= '<div class="ppt_delete"><a href="javascript:void(0)" class="ppt-link-btn sz-ppt-delete">DELETE</a></div>';
            trousersHTML+= '</div></div>';
            trousersHTML+= '<a href="javascript:void(0)" class="select-passport-btn-outline select-passport-btn">'+btn_txt+'</a>';
            trousersHTML+= '</div>';
            myPassport.push(trouserPassport[i]);
          }
          counter+= 1;
        }
        trousersHTML+= '<input type="button" class="ppt-outline-btn full-btn" value="+ CREATE NEW PASSPORT" data-passport="create-trousers-size-passport">';
        trousersHTML+= '</div>';
        $(`.sz-ppt-modifier-multidrawer-slidewrap [drawer-step="12"]`).find(".sz-ppt-middle").append(trousersHTML);
        if(checkCustomMade() == true){
          $("body").removeClass("size-line-loading");
        }
      }

      if(_this.parents(".custom-made-suit").length > 0 && (type == 'waistcoat' || type == 'suits' || type == 'tuxedo waistcoat' || type == 'tuxedo suits')){
        var waistcoatHTML = '';
        let dataPage = _this.parents(".custom-made-suit").find(".template-page").attr("data-page");

        if(_this.parents(".custom-made-suit").find(".cm-waistcoat-disabled").length == 1 && (dataPage == 'custom-made-suit' || dataPage == 'custom-made-tuxedo-suit')){
          waistcoatHTML+= '<div class="sz-ppt-mybox-wrapper hide" data-type="waistcoat-passport">';
        }else{
          waistcoatHTML+= '<div class="sz-ppt-mybox-wrapper" data-type="waistcoat-passport">';
        }
        waistcoatHTML+= '<h2>WAISTCOAT SIZE PASSPORTS</h2><span class="delete-msg hide"></span>';
      
        if(passports.data.waistcoat && passports.data.waistcoat.length > 0){
          let waistcoatPassport = passports.data.waistcoat;
          for(let i=0; i<waistcoatPassport.length; i++){
            waistcoatHTML+= '<div class="sz-ppt-mybox" data-key="'+waistcoatPassport[i]['uid']+'" data-userid="'+decode(passports.data.user_id, 11)+'" data-size="'+waistcoatPassport[i]['baseSize']+'">';
            waistcoatHTML+= '<div class="sz-ppt-mybox-in" data-title="'+waistcoatPassport[i]['passport_name']+'"><h2>*'+waistcoatPassport[i]['passport_name']+'*</h2>';
            waistcoatHTML+= '<p>BASE SIZE:</p><p>'+waistcoatPassport[i]['baseSize']+'</p>';
            waistcoatHTML+= '<div class="ppt_edit_delete">';
            waistcoatHTML+= '<div class="ppt_edit"><a href="javascript:void(0)" class="ppt-link-btn">EDIT</a></div>';
            waistcoatHTML+= '<div class="ppt_delete"><a href="javascript:void(0)" class="ppt-link-btn sz-ppt-delete">DELETE</a></div>';
            waistcoatHTML+= '</div></div>';
            waistcoatHTML+= '<a href="javascript:void(0)" class="select-passport-btn-outline select-passport-btn">'+btn_txt+'</a>';
            waistcoatHTML+= '</div>';
            myPassport.push(waistcoatPassport[i]);
          }
          counter+= 1;
        }
        waistcoatHTML+= '<input type="button" class="ppt-outline-btn full-btn" value="+ CREATE NEW PASSPORT" data-passport="create-waistcoat-size-passport">';
        waistcoatHTML+= '</div>';
        $(`.sz-ppt-modifier-multidrawer-slidewrap [drawer-step="12"]`).find(".sz-ppt-middle").append(waistcoatHTML);
        if(checkCustomMade() == true){
          $("body").removeClass("size-line-loading");
        }
      }

      if(type == 'shirts' || type == 'shirt' || type == 'tuxedo shirts' || type == 'tuxedo shirt'){
        var shirtHTML = '';
        shirtHTML+= '<div class="sz-ppt-mybox-wrapper" data-type="shirt-passport">';
        shirtHTML+= '<h2>SHIRT SIZE PASSPORTS</h2><span class="delete-msg hide"></span>';
      
        if(passports.data.shirt && passports.data.shirt.length > 0){
          let shirtPassport = passports.data.shirt;
          for(let i=0; i<shirtPassport.length; i++){
            shirtHTML+= '<div class="sz-ppt-mybox" data-key="'+shirtPassport[i]['uid']+'" data-userid="'+decode(passports.data.user_id, 11)+'" data-size="'+shirtPassport[i]['baseSize']+'">';
            shirtHTML+= '<div class="sz-ppt-mybox-in" data-title="'+shirtPassport[i]['passport_name']+'"><h2>*'+shirtPassport[i]['passport_name']+'*</h2>';
            shirtHTML+= '<p>BASE SIZE:</p><p>'+shirtPassport[i]['baseSize']+'</p>';
            shirtHTML+= '<div class="ppt_edit_delete">';
            shirtHTML+= '<div class="ppt_edit"><a href="javascript:void(0)" class="ppt-link-btn">EDIT</a></div>';
            shirtHTML+= '<div class="ppt_delete"><a href="javascript:void(0)" class="ppt-link-btn sz-ppt-delete">DELETE</a></div>';
            shirtHTML+= '</div></div>';
            shirtHTML+= '<a href="javascript:void(0)" class="select-passport-btn-outline select-passport-btn">'+btn_txt+'</a>';
            shirtHTML+= '</div>';
            myPassport.push(shirtPassport[i]);
          }
          counter+= 1;
        }
        shirtHTML+= '<input type="button" class="ppt-outline-btn full-btn" value="+ CREATE NEW PASSPORT" data-passport="create-shirt-size-passport">';
        shirtHTML+= '</div>';
        $(`.sz-ppt-modifier-multidrawer-slidewrap [drawer-step="12"]`).find(".sz-ppt-middle").append(shirtHTML);
        if(checkCustomMade() == true){
          $("body").removeClass("size-line-loading");
        }
      }

      if(type == 'raglan coats'){
        var raglanCoatsHTML = '';
        raglanCoatsHTML+= '<div class="sz-ppt-mybox-wrapper" data-type="raglan-coats-passport">';
        raglanCoatsHTML+= '<h2>RAGLAN COAT SIZE PASSPORTS</h2><span class="delete-msg hide"></span>';
      
        if(passports.data.raglan_coats && passports.data.raglan_coats.length > 0){
          let raglanCoatPassport = passports.data.raglan_coats;
          for(let i=0; i<raglanCoatPassport.length; i++){
            raglanCoatsHTML+= '<div class="sz-ppt-mybox" data-key="'+raglanCoatPassport[i]['uid']+'" data-userid="'+decode(passports.data.user_id, 11)+'" data-size="'+raglanCoatPassport[i]['baseSize']+'">';
            raglanCoatsHTML+= '<div class="sz-ppt-mybox-in" data-title="'+raglanCoatPassport[i]['passport_name']+'"><h2>*'+raglanCoatPassport[i]['passport_name']+'*</h2>';
            raglanCoatsHTML+= '<p>BASE SIZE:</p><p>'+raglanCoatPassport[i]['baseSize']+'</p>';
            raglanCoatsHTML+= '<div class="ppt_edit_delete">';
            raglanCoatsHTML+= '<div class="ppt_edit"><a href="javascript:void(0)" class="ppt-link-btn">EDIT</a></div>';
            raglanCoatsHTML+= '<div class="ppt_delete"><a href="javascript:void(0)" class="ppt-link-btn sz-ppt-delete">DELETE</a></div>';
            raglanCoatsHTML+= '</div></div>';
            raglanCoatsHTML+= '<a href="javascript:void(0)" class="select-passport-btn-outline select-passport-btn">'+btn_txt+'</a>';
            raglanCoatsHTML+= '</div>';
            myPassport.push(raglanCoatPassport[i]);
          }
          counter+= 1;
        }
        raglanCoatsHTML+= '<input type="button" class="ppt-outline-btn full-btn" value="+ CREATE NEW PASSPORT" data-passport="create-coat-passport">';
        raglanCoatsHTML+= '</div>';
        $(`.sz-ppt-modifier-multidrawer-slidewrap [drawer-step="12"]`).find(".sz-ppt-middle").append(raglanCoatsHTML);
        if(checkCustomMade() == true){
          $("body").removeClass("size-line-loading");
        }
      }

      if(type == 'overcoats'){
        var overcoatsHTML = '';
        overcoatsHTML+= '<div class="sz-ppt-mybox-wrapper" data-type="overcoats-passport">';
        overcoatsHTML+= '<h2>OVERCOAT SIZE PASSPORTS</h2><span class="delete-msg hide"></span>';
      
        if(passports.data.overcoats && passports.data.overcoats.length > 0){
          let overcoatsPassport = passports.data.overcoats;
          for(let i=0; i<overcoatsPassport.length; i++){
            overcoatsHTML+= '<div class="sz-ppt-mybox" data-key="'+overcoatsPassport[i]['uid']+'" data-userid="'+decode(passports.data.user_id, 11)+'" data-size="'+overcoatsPassport[i]['baseSize']+'">';
            overcoatsHTML+= '<div class="sz-ppt-mybox-in" data-title="'+overcoatsPassport[i]['passport_name']+'"><h2>*'+overcoatsPassport[i]['passport_name']+'*</h2>';
            overcoatsHTML+= '<p>BASE SIZE:</p><p>'+overcoatsPassport[i]['baseSize']+'</p>';
            overcoatsHTML+= '<div class="ppt_edit_delete">';
            overcoatsHTML+= '<div class="ppt_edit"><a href="javascript:void(0)" class="ppt-link-btn">EDIT</a></div>';
            overcoatsHTML+= '<div class="ppt_delete"><a href="javascript:void(0)" class="ppt-link-btn sz-ppt-delete">DELETE</a></div>';
            overcoatsHTML+= '</div></div>';
            overcoatsHTML+= '<a href="javascript:void(0)" class="select-passport-btn-outline select-passport-btn">'+btn_txt+'</a>';
            overcoatsHTML+= '</div>';
            myPassport.push(overcoatsPassport[i]);
          }
          counter+= 1;
        }
        overcoatsHTML+= '<input type="button" class="ppt-outline-btn full-btn" value="+ CREATE NEW PASSPORT" data-passport="create-coat-passport">';
        overcoatsHTML+= '</div>';
        $(`.sz-ppt-modifier-multidrawer-slidewrap [drawer-step="12"]`).find(".sz-ppt-middle").append(overcoatsHTML);
        if(checkCustomMade() == true){
          $("body").removeClass("size-line-loading");
        }
      }

      window.findData = true;

      /*if(_this.parents(".sz-ppt-sb-panel").attr("data-staff-member")) {
        $(`.sz-ppt-modifier-multidrawer-slidewrap [drawer-step="12"]`).find(".sz-ppt-footer .add-to-cart-passport").addClass("disabled");
        $(`.sz-ppt-modifier-multidrawer-slidewrap [drawer-step="12"]`).find(".sz-ppt-middle .select-passport-btn.selected").removeClass("selected");
      }*/
    }

    // Add passport id in the local storage
    let savedPassports = [];
    Object.entries(passports.data).forEach(([type, passports]) => {
      if (!Array.isArray(passports)) return; // skip user_id
      passports.forEach(passport => {
        const uidEntry = Object.entries(passport).find(([key]) => key.includes('uid'));
        if (uidEntry) {
          const uid = uidEntry[1];
          if (!savedPassports.includes(uid)) {
            savedPassports.push(uid);
          }
        }
      });
    });

    //console.log('savedPassports', savedPassports);
    localStorage.setItem('passport_list', JSON.stringify(savedPassports));
   
    if(counter > 0){
      if($(`.sz-ppt-modifier-multidrawer-slidewrap [drawer-step="12"]`).find(".sz-ppt-footer").hasClass("hide")){
        $(`.sz-ppt-modifier-multidrawer-slidewrap [drawer-step="12"]`).find(".sz-ppt-footer").removeClass("hide");
      }
    }

    if(_this.parents(".customer-search").length > 0){
      //Go back in search drawer (when staff member logged in)
      let step = _this.parents(".sz-ppt-progress-container").attr("drawer-step");
      let targetstep = $(`.sz-ppt-modifier-multidrawer-slidewrap [data-id="my-passport-detail"]`).attr("drawer-step");
      changeStep(step, targetstep);
    }else{
      $(".sz-ppt-modifier-multidrawer-slidewrap").find(".isSelected").removeClass("isSelected");
      $(".sz-ppt-modifier-multidrawer-slidewrap").find(".isBacked").removeClass("isBacked");
      $(`.sz-ppt-modifier-multidrawer-slidewrap [data-id="my-passport-detail"]`).addClass('isSelected');
    }
    openMainDrawer();
    //console.log('myPassport', myPassport)
  }
  
  // Open passport drawer
  window.openMainDrawer = function(){
    $('body').addClass('sz-ppt-open');
    $('html').addClass("size-ppt-pop-open");
  }

  window.closeMainDrawer = function() {
    $('body').removeClass('sz-ppt-open');
    $('html').removeClass("size-ppt-pop-open");
  }

  //Add to cart
  function addToBag(id, quantity=1, properties, thisObject){
    thisObject.parent(".progressBarWrap").addClass("line-loading");
    CartJS.addItem(
      id,
      quantity,
      properties,
      {
        success: function (data, textStatus, jqXHR) {
          getCartDrawer();
          thisObject.parent(".progressBarWrap").removeClass("line-loading");

          if(thisObject.parents(".sz-ppt-progress-container").hasClass("mix-match-size")){
            if(thisObject.parents(".sz-ppt-inside-container").data("id") == 'Jacket' && isJacket == false){
              counter = counter + 1;
              isJacket = true
            }
            if(thisObject.parents(".sz-ppt-inside-container").data("id") == 'Trousers' && isTrousers == false){
              counter = counter + 1;
              isTrousers = true
            }
          }
          
          if(thisObject.parents(".sz-ppt-progress-container").find(".sz-ppt-view-cart-footer").length > 0){
            // Mix & Match product
            thisObject.parents(".sz-ppt-inside-container").find(".sz-ppt-bck-btn").trigger("click");
            if(counter >= 2){
              // when add both jacket & trouers in cart open cart drawer (Mix & Match product)
              setTimeout(function () {
                $(".site-header__cart").trigger("click");
                $("html").addClass("back-fixed");
              }, 500);
            }else{
              // when add any one from jacket or trouers in cart (Mix & Match product)
              thisObject.parents(".sz-ppt-progress-container").find(".sz-ppt-view-cart-footer").addClass("active");
              setTimeout(function () {
                thisObject.parents(".sz-ppt-progress-container").find(".sz-ppt-view-cart-footer").removeClass("active");
              }, 3000);
            }
            thisObject.parents(".sz-ppt-inside-container").find(".sz-ppt-size-var-item.active").removeClass("active");
            thisObject.parents(".sz-ppt-inside-container").find(".sz-ppt-footer .select-mix-match-size").addClass("disabled").val("SELECT SIZE");
          }else{
            setTimeout(function () {
              $(".site-header__cart").trigger("click");
              $("html").addClass("back-fixed");
              window.media = [];
              if(document.querySelector('.cm-uploaded-media-preview')) {
                document.querySelector('.cm-uploaded-media-preview').innerHTML = '';
              }
              if(document.querySelector('.cm-uploaded-media-preview-final')) {
                document.querySelector('.cm-uploaded-media-preview-final').innerHTML = '';
              }
            }, 500);
          }
        },
        error: function (jqXHR, textStatus, errorThrown) {
          var errormsg = JSON.parse(jqXHR.responseText).description;
          thisObject.parent(".progressBarWrap").removeClass("line-loading");
          thisObject.parents(".sz-ppt-inside-container").find(".error-msg").text(errormsg);
        }
      }
    );
  }

  // Get all measurements
  function getMeasurements(thisObj, type){
    let _this = thisObj;
    let parentContainer = _this.parents('.sz-ppt-progress-container');
    let customerId = _this.parents(".sz-ppt-sb-panel").attr("data-customer");
    let currentDrawerStep = parentContainer.attr("drawer-step");

    let preferences = {};
    if(_this.parents(".parent-container").find("#fit-preference").length > 0) {
      // for garment measurement
      let value = _this.parents(".parent-container").find("#fit-preference").find(".sz-ppt-preference_active").attr("data-title").replaceAll(" ", "-").toLowerCase();
      preferences['fit'] = value;
    } else {
      // for body measurement
      if(type == "save") {
        _this.parents(".sz-ppt-inside-container").find("#fitPreference .szpt-pre-grid").each(function(index) {
          let finalKey = $(this).find("h2").text().replace(" ", "_").toLowerCase();
          let finalValue = $(this).find(".preference_active").attr("data-title").replaceAll("  ", "-").replaceAll(" ", "-").toLowerCase();
          preferences[finalKey] = finalValue;    
        });

        _this.parents(".sz-ppt-inside-container").find("#fitPreference .sz-ppt-size-input").each(function(index) {
          let finalKey = $(this).find("label span").text().replace(" ", "_").toLowerCase();
          let finalValue = $(this).find(".sz-ppt-dropdwn-ele option:selected").attr("data-val").replaceAll(" ", "-").toLowerCase();
          preferences[finalKey] = finalValue;
        });
      } else if(type == "update") {
        preferences = globalObj[0]?.preferences || {};
      }
      
    }
    //return false;
    
    /* Validation for the chest and upper waist */
    const chest = parseFloat(parentContainer.find(".inside-selected").find(".sz-ppt-tabs-Grid.selected").find(".input_bx_cls.chest").val() || '');
    const upperWaist = parseFloat(parentContainer.find(".inside-selected").find(".sz-ppt-tabs-Grid.selected").find(".input_bx_cls.upper_waist").val() || '');
    const isValid = Number.isFinite(chest) && Number.isFinite(upperWaist);

    if(isValid) {
      if(chest < upperWaist) {
        _this.parents(".sz-ppt-footer").find(".sz-ppt-field-err").remove();
        _this.parents(".sz-ppt-footer").prepend("<span class='sz-ppt-msg sz-ppt-error-msg sz-ppt-field-err sz-ppt-validation-msg1'>Chest must be greater than to Upper Waist.</span>");
        const element = parentContainer.find(".inside-selected").find(".sz-ppt-tabs-Grid.selected").find(".input_bx_cls.chest");
        if (element.length) {
          element[0].scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
        return false;
      } else {
        _this.parents(".sz-ppt-footer").find(".sz-ppt-field-err").remove();
      }
    }
    /* End Validation for the chest and upper waist */

    if(_this.hasClass("sz-ppt-login-btn")){
      changeStep(currentDrawerStep, 8);
    }else{
      let valuesObject = {
        type: parentContainer.attr('data-id'),
        baseSize: selectedSize,
        preferences,
        beforeMeasurement: {
          basic: {},
          advance: {}
        },  
        measurements: {
          basic: {},
          advance: {}
        }
      };

      if(parentContainer.find('#suggestedMeasurements .sz-ppt-size-inptbx.outer_box').length){
        valuesObject['measureUnit'] = parentContainer.find('#suggestedMeasurements input[type="checkbox"]').prop('checked') ? 'inch' : 'cm';
      }else{
        valuesObject['measureUnit'] = parentContainer.find('.sz-ppt-size-toggle input[type="checkbox"]').prop('checked') ? 'inch' : 'cm';
      }

      // collect upper/lower body measurement data
      if(parentContainer.hasClass("body-measurement")){
        let bodyInputBoxes = parentContainer.find(".inside-selected .sz-ppt-tabs-Grid").eq(0).find('.sz-ppt-size-inptbx.outer_box');
        bodyInputBoxes.each(function () {
          let inputElement = $(this).find('.sz-ppt-size-input-ele').not(".hide");
          let inputName = inputElement.attr('name').replaceAll("(", "").replaceAll(")", "");
          let inputValue = inputElement.val();
      
          if (inputName) {
            if(!inputElement.parents(".sz-ppt-size-unt-inpts").hasClass("adv_opt")){
              if(inputElement.length > 1) {
                let heightFt = parseInt($(this).parents(".sz-ppt-inside-container").find('.height_fit').val());
                let heightInch = parseInt($(this).parents(".sz-ppt-inside-container").find('.height_inch').val());
                if(heightFt > 0 && heightInch > -1) {
                  if(valuesObject['measureUnit'] == 'inch') {
                    valuesObject.beforeMeasurement.basic[inputName] = feetInchesToInch(heightFt, heightInch).toString();
                  } else {
                    valuesObject.beforeMeasurement.basic[inputName] = feetInchesToCm(heightFt, heightInch);
                  } 
                }
              } else {
                valuesObject.beforeMeasurement.basic[inputName] = inputValue.trim();
              }
            }else{
              valuesObject.beforeMeasurement.advance[inputName] = inputValue.trim();
            }
          }
        });
      }

      // collect final tab (suggested) measurement data
      let inputBoxes = parentContainer.find('#suggestedMeasurements .sz-ppt-size-inptbx.outer_box').length 
        ? parentContainer.find('#suggestedMeasurements .sz-ppt-size-inptbx.outer_box') 
        : parentContainer.find('.sz-ppt-size-inptbx.outer_box');
      let hasError = false; // Error flag

      inputBoxes.each(function () {
        let inputElement = $(this).find('.sz-ppt-size-input-ele').not(".hide");
        let inputName = inputElement.attr('name').replaceAll("(", "").replaceAll(")", "");
        let inputValue = inputElement.val();
    
        if (inputName) {
          inputElement.removeClass('err-msg-passport');
  
          if(!inputElement.parents(".sz-ppt-size-unt-inpts").hasClass("adv_opt")){
            if (!inputValue || inputValue <= 0) {
              hasError = true;
              inputElement.addClass('err-msg-passport');
              inputElement.parents(".sz-ppt-size-input").removeClass("opacity_cls").focus();
              inputElement.first()[0].scrollIntoView({ behavior: 'smooth', block: 'center' });
              return false;
            } else {
             valuesObject.measurements.basic[inputName] = inputValue.trim();
            }
          }else{
            if (inputValue && inputValue != 0) {
              valuesObject.measurements.advance[inputName] = inputValue.trim();
            }
          }
        }
      });

      if(hasError) { return false; }
    
      let passportName = parentContainer.find('.save-passport-name input').val().trim().toUpperCase();
      if (passportName === "") {
        hasError = true;
        parentContainer.find('.save-passport-name input').addClass('sz-ppt-empty-title').focus();
        parentContainer.find('.save-passport-name input')[0].scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }else{
        parentContainer.find('.save-passport-name input').removeClass('sz-ppt-empty-title');
        valuesObject['passport_name'] = passportName;
      }

      if (!hasError && customerId){
        return valuesObject;
      }
    }
  }

  function checkChestValidation (chest, upperWaist, _this, callback) {
    
  }

  // Erase all previous edited data
  function clearPrevMeasureData(thisObj){
    let _this = thisObj;
    _this.find(".sz-ppt-msg").removeClass("sz-ppt-success-msg").removeClass("sz-ppt-error-msg").text('');
    _this.find(".sz-passport-name").val('');
    _this.find(".sz-passport-name").hasClass("sz-ppt-empty-title") ? _this.find(".sz-passport-name").removeClass("sz-ppt-empty-title") : '';
    _this.find(".sz-ppt-middle .sz-ppt-size-input").addClass('opacity_cls');
    if(currCountry != 'US'){
      _this.find("input[type='checkbox']").prop("checked", false);
      _this.find(".sz-ppt-middle .sz-ppt-size-input .sz-ppt-dropdown-inch").addClass("hide");
      _this.find(".sz-ppt-middle .sz-ppt-size-input .sz-ppt-dropdown-cm").removeClass("hide");
    }
    _this.find(".sz-ppt-size-unt-inpts input.sz-ppt-size-input-ele").val('');
    _this.find('.sz-ppt-size-unt-inpts .sz-ppt-ip-right, .sz-ppt-size-unt-inpts .sz-ppt-ip-left').remove();
    _this.find(".sz-ppt-middle .select-size-btn").removeClass("isSelect").text('SELECT BASE SIZE');
    _this.find(".sz-ppt-middle .fit-preference").removeClass("isSelect disabled").text('FIT PREFERENCE');
    _this.find('[drawer-id="2"]').find(".sz-ppt-size-var-item.active").removeClass("active");
    _this.find('[drawer-id="3"]').find(".sz-ppt-preference_active").removeClass("sz-ppt-preference_active");
    _this.find('[drawer-id="2"]').find(".fetch-size-btn").addClass("disabled");
    _this.find('[drawer-id="3"]').find(".fetch-pref-btn").addClass("disabled");
    _this.find(".adv_opt").removeClass("active-adv-options");
    _this.find(".sz-ppt-advanced-options").addClass("opacity_cls").removeClass("active");
  }

  
  // Convert body measurement data to garment measurement
  let finalMeasure = [];
  let recomendedSizes;

  // Calculate measurements based on chest and height category for JACKET (base measurement)
  async function bodyToGarmentJacketConvertor(parentWrapper, bodyTab, fitPreferenceTab, suggestedMeasurementsTab, measureUnit, url) {
    let chest;
    let userSize = {
      height: measureUnit ? (bodyTab.find('.height_fit').length > 0 ? feetInchesToCm(bodyTab.find('.height_fit').val(), bodyTab.find('.height_inch').val())
        : convertTo(parseFloat(bodyTab.find('.outer_box input.height').val().trim()), ''))
      : parseFloat(bodyTab.find('.outer_box input.height').val().trim()),
    
      chest: measureUnit 
        ? convertTo(parseFloat(bodyTab.find('.outer_box input.chest').val().trim()), '') 
        : parseFloat(bodyTab.find('.outer_box input.chest').val().trim()),
    
      shoulder: measureUnit 
        ? convertTo(parseFloat(bodyTab.find('.outer_box input.shoulders').val()), '') 
        : parseFloat(bodyTab.find('.outer_box input.shoulders').val().trim()),
    
      upperWaist: measureUnit 
        ? convertTo(parseFloat(bodyTab.find('.outer_box input.upper_waist').val()), '') 
        : parseFloat(bodyTab.find('.outer_box input.upper_waist').val().trim()),
    
      hip: measureUnit 
        ? convertTo(parseFloat(bodyTab.find('.outer_box input.hip').val()), '') 
        : parseFloat(bodyTab.find('.outer_box input.hip').val().trim()),
    
      biceps: measureUnit 
        ? convertTo(parseFloat(bodyTab.find('.outer_box input.biceps').val()), '') 
        : parseFloat(bodyTab.find('.outer_box input.biceps').val().trim()),
    
      armLength: measureUnit 
        ? convertTo(parseFloat(bodyTab.find('.outer_box input.arm_length').val()), '') 
        : parseFloat(bodyTab.find('.outer_box input.arm_length').val().trim()),
    
      chestType: bodyTab.find('select.sz-ppt-dropdwn-ele.chest_type').val(),
      stomachType: bodyTab.find('select.sz-ppt-dropdwn-ele.stomach_type').val(),
      fitPreference: fitPreferenceTab.find('.preference_active').attr('data-title').toLowerCase().replace(" ", "-") || 'tailored-fit',
      jacketLength: fitPreferenceTab.find('select.sz-ppt-dropdwn-ele.jacket_length').val(),
      measureUnit: measureUnit ? 'inch' : 'cm',
      url: url
    };

    let heightCategory = getHeightCategory(userSize.height, 'jacket');
    chest = getChestMeasurement(parseFloat(userSize.chest), heightCategory, 'jacket');

    if(url) {
      recomendedSizes = await findNearestJacketSize(chest, userSize.height, 3, url);
      measureObj.push(recomendedSizes);
    }

    if(recomendedSizes){
      $("#suggestedMeasurements .sz-ppt-size-actions").find(".sz-ppt-error-msg").remove();
      let bodyMeasurements = await calculateBaseMeasurements(chest, heightCategory, recomendedSizes, userSize);
      let measurements = await calculateAdvMeasurements(userSize, bodyTab);
      if(measurements){
        setSuggestedMeasureTab(measurements, suggestedMeasurementsTab, parentWrapper, recomendedSizes);
      }
    }else {
      baseSizeNotFound('chest');
    }
  }

  async function calculateBaseMeasurements(chest, heightCategory, recomendedSizes, userSize) {
    finalMeasure = [];
    finalMeasure.push({
      'base_size': recomendedSizes.size,
      'unit': userSize.measureUnit,
      'height': parseFloat(userSize.height),
      'chest': chest,
      'shoulders': getShoulderMeasurement(userSize.shoulder, recomendedSizes.shoulders, 0.5, 4, 4)
    });
    let { upperWaist, newChest } = getUpperWaistMeasurement (chest, userSize, 'jacket');
  
    finalMeasure[0]['upper_waist'] = upperWaist;
    if(newChest){
      //recomendedSizes = await findNearestSize(newChest, heightCategory, 3, userSize.url, '', 'jacket');
      recomendedSizes = await findNearestJacketSize(newChest, userSize.height, 3, userSize.url);
      
      if(recomendedSizes){
        finalMeasure[0]['shoulders'] = getShoulderMeasurement(userSize.shoulder, recomendedSizes.shoulders, 0.5, 4, 4);
        finalMeasure[0]['base_size'] = recomendedSizes.size;
      }
      finalMeasure[0]['chest'] = newChest;
    }

    //finalMeasure[0]['hip'] = heightCategory == 'short' ? parseFloat(userSize.hip) + 5 : parseFloat(userSize.hip) + 6;

    finalMeasure[0]['hip'] = parseFloat(userSize.hip) + 4;
    if(finalMeasure[0]['hip'] < finalMeasure[0]['upper_waist']) {
      finalMeasure[0]['hip'] = parseFloat(recomendedSizes.hip) - 3;
    }

    finalMeasure[0]['biceps'] = userSize.biceps > 40 ? parseFloat(recomendedSizes.biceps) + 1.5 : parseFloat(recomendedSizes.biceps);
    finalMeasure[0]['back_length'] = getBackLengthBasedOnHeight(userSize.height)/*parseFloat(recomendedSizes.back_length) * 1*/;
    finalMeasure[0]['sleeve_opening'] = userSize.biceps > 40 ? parseFloat(recomendedSizes.sleeve_opening) + 1 : parseFloat(recomendedSizes.sleeve_opening);
    finalMeasure[0]['sleeve_length_left'] = parseFloat(userSize.armLength) + 2;
    finalMeasure[0]['sleeve_length_right'] = parseFloat(userSize.armLength) + 2;
    return finalMeasure;
  }

  async function calculateAdvMeasurements(userSize, bodyTab){
    let chestType = userSize.chestType.toLowerCase();
    let stomachType = userSize.stomachType.toLowerCase();
    let fitPref = userSize.fitPreference.toLowerCase();
    let jacketLength = userSize.jacketLength.toLowerCase();

    bodyTab.find(".sz-ppt-dropdwn-ele").each(function() {
      let name = $(this).attr("name");
      let value = $(this).val();
      if(!$(this).hasClass("hide")){
        finalMeasure[0][name] = value;
      }
    });
    
    if(chestType == 'muscular'){
      finalMeasure[0]['chest'] = finalMeasure[0]['chest'] + 2;
    }
    if(stomachType == 'round stomach'){
      finalMeasure[0]['upper_waist'] = finalMeasure[0]['upper_waist'] + 2;
      finalMeasure[0]['skirt'] = finalMeasure[0]['unit'] == 'cm' ? "- 2.0 cm: Smaller" : "- 2.0 in: Smaller"
    }
    if(chestType == 'muscular' && stomachType == 'flat stomach'){
      finalMeasure[0]['darts'] = "- 1.0: Take in darts slightly";
    }

    if(fitPref.includes('casual')){
      finalMeasure[0]['chest'] = finalMeasure[0]['chest'] + 2;
      finalMeasure[0]['upper_waist'] = finalMeasure[0]['chest'] - 2;
      finalMeasure[0]['hip'] = finalMeasure[0]['chest'] - 2;
      finalMeasure[0]['biceps'] = finalMeasure[0]['biceps'] + 2;
      //finalMeasure[0]['wrist'] = finalMeasure[0]['wrist'] + 2.5;
      finalMeasure[0]['sleeve_opening'] = finalMeasure[0]['sleeve_opening'] + 3;
      finalMeasure[0]['shoulders'] = finalMeasure[0]['shoulders'] + 1.5;
    }
    if(jacketLength.includes('longer')){
      finalMeasure[0]['back_length'] = finalMeasure[0]['back_length'] + 2;
    }else if(jacketLength.includes('shorter')){
      finalMeasure[0]['back_length'] = finalMeasure[0]['back_length'] - 2;
    }

    finalMeasure[0]['chest_type'] = userSize.chestType;
    finalMeasure[0]['stomach_type'] = userSize.stomachType;
    finalMeasure[0]['fit_preference'] = fitPref;
    finalMeasure[0]['jacket_length'] = userSize.jacketLength;
    return finalMeasure;
  }

  // Calculate measurements based on waist and height category for TROUSERS (base measurement)
  async function bodyToGarmentTrousersConvertor(parentWrapper, bodyTab, fitPreferenceTab, suggestedMeasurementsTab, measureUnit, url, taperedURL, wideURL, extraWideURL) {
    let waist;
    let userSize = {
      height: measureUnit ? (bodyTab.find('.height_fit').length > 0 ? feetInchesToCm(bodyTab.find('.height_fit').val(), bodyTab.find('.height_inch').val())
        : convertTo(parseFloat(bodyTab.find('.outer_box input.height').val().trim()), ''))
      : parseFloat(bodyTab.find('.outer_box input.height').val().trim()),
    
      waist: measureUnit 
        ? convertTo(parseFloat(bodyTab.find('.outer_box input.waist').val().trim()), '') 
        : parseFloat(bodyTab.find('.outer_box input.waist').val().trim()),
    
      hip: measureUnit
        ? convertTo(parseFloat(bodyTab.find('.outer_box input.hip').val().trim()), '') 
        : parseFloat(bodyTab.find('.outer_box input.hip').val().trim()),
    
      thigh: measureUnit 
        ? convertTo(parseFloat(bodyTab.find('.outer_box input.thigh').val().trim()), '') 
        : parseFloat(bodyTab.find('.outer_box input.thigh').val().trim()),
    
      calf: measureUnit 
        ? convertTo(parseFloat(bodyTab.find('.outer_box input.calf').val().trim()), '') 
        : parseFloat(bodyTab.find('.outer_box input.calf').val().trim()),
    
      inseam: measureUnit 
        ? convertTo(parseFloat(bodyTab.find('.outer_box input.inseam').val().trim()), '') 
        : parseFloat(bodyTab.find('.outer_box input.inseam').val().trim()),
    
      pelvicTilt: bodyTab.find('select.sz-ppt-dropdwn-ele.pelvic_tilt').val(),
      fitPrefRise: fitPreferenceTab.find('.fit_pref_rise .preference_active').attr('data-title').toLowerCase().replace(" ", "-"),
      fitPrefShape: fitPreferenceTab.find('.fit_pref_shape .preference_active').attr('data-title').toLowerCase().replaceAll(" ", "-") || 'straight',
      measureUnit: measureUnit ? 'inch' : 'cm',
      url: url,
      taperedUrl: taperedURL,
      wideURL: wideURL,
      extraWideURL: extraWideURL
    };
    
    let heightCategory = getHeightCategory(userSize.height, 'trousers');
    waist = parseFloat(userSize.waist) + 1;

    if(userSize.fitPrefShape.toLowerCase().includes("straight")){
      url = userSize.url;
    }else if(userSize.fitPrefShape.toLowerCase().includes("tapered")){
      url = userSize.taperedUrl;
    }else if (userSize.fitPrefShape.toLowerCase() == "wide-fit" || userSize.fitPrefShape.toLowerCase() == "wide"){
      url = userSize.wideURL;
    }else if (userSize.fitPrefShape.toLowerCase().includes("extra-wide")){
      url = userSize.extraWideURL;
    }

    if(url) {
      recomendedSizes = await findNearestSize(waist, heightCategory, 1, url, 'waist', 'trousers');
    }

    if(recomendedSizes){
      measureObj.push(recomendedSizes);
      $("#suggestedMeasurements .sz-ppt-size-actions").find(".sz-ppt-error-msg").remove();
      let bodyMeasurements = await calculateTrousersBaseMeasurements(waist, heightCategory, recomendedSizes, userSize);
      let measurements = await calcTrousersAdvMeasurements(waist, userSize, recomendedSizes, bodyTab, heightCategory);
      if(measurements){
        setSuggestedMeasureTab(measurements, suggestedMeasurementsTab, parentWrapper, recomendedSizes);
      }
    }else {
      baseSizeNotFound('waist');
    }
  }

  async function calculateTrousersBaseMeasurements(waist, heightCategory, recomendedSizes, userSize){
    finalMeasure = [];
    finalMeasure.push({
      'base_size': recomendedSizes.size,
      'unit': userSize.measureUnit,
      'height': Number(userSize.height),
      'waist': waist,
      'hip': Number(userSize.hip) + 14 /*checkLimit(userSize.hip, recomendedSizes.hip, 0, 10, 10)*/,
      'thigh': checkLimit(userSize.thigh, recomendedSizes.thigh, 5, 7, 7),
      'calf': Number(recomendedSizes.calf),
      'leg_opening': Number(recomendedSizes.leg_opening),
      'inseam': Number(userSize.inseam)
    });
    return finalMeasure;
  }

  async function calcTrousersAdvMeasurements(waist, userSize, recomendedSizes, bodyTab, heightCategory){
    let pelvicTilt = userSize.pelvicTilt.toLowerCase();
    let fitPreferenceRise = userSize.fitPrefRise.toLowerCase();
    let fitPreferenceShape = userSize.fitPrefShape.toLowerCase();
    
    finalMeasure[0]['pelvic_tilt'] = userSize.pelvicTilt;

    let { front_rise, back_rise } = getFrontRise (fitPreferenceRise, heightCategory);
    finalMeasure[0]['front_rise'] = front_rise;
    finalMeasure[0]['back_rise'] = back_rise;
    
    if(pelvicTilt.includes('forward')){
      finalMeasure[0]['front_rise'] = finalMeasure[0]['front_rise'] - 1;
      finalMeasure[0]['back_rise'] = finalMeasure[0]['back_rise'] + 1;
      finalMeasure[0]['pelvic_tilt_pattern'] = '6KN358 / 6KN366 / 6KN363';
    }

    let recomendedNewSizes;
    if(fitPreferenceShape.includes("tapered")){
      recomendedNewSizes = await findNearestSize(waist, heightCategory, 1, userSize.taperedUrl, 'waist', 'trousers');
    }else if (fitPreferenceShape == "wide-fit" || fitPreferenceShape == "wide"){
      recomendedNewSizes = await findNearestSize(waist, heightCategory, 1, userSize.wideURL, 'waist', 'trousers');
      finalMeasure[0]['thigh'] = finalMeasure[0]['thigh'] + 2;
    }else if (fitPreferenceShape.includes("extra-wide")){ 
      recomendedNewSizes = await findNearestSize(waist, heightCategory, 1, userSize.extraWideURL, 'waist', 'trousers');
    }

    if(recomendedNewSizes){
      finalMeasure[0]['calf'] = Number(recomendedNewSizes.calf);
      finalMeasure[0]['leg_opening'] = Number(recomendedNewSizes.leg_opening);
    }

    finalMeasure[0]['fit_preference_rise'] = userSize.fitPrefRise;
    finalMeasure[0]['fit_preference_shape'] = userSize.fitPrefShape;
    return finalMeasure;
  }

  function getFrontRise(rise, height){
    let front_rise, back_rise;

    if(height == 'short'){
      if(rise.includes('high')){
        front_rise = 30, back_rise = 43;
      }else if (rise.includes('medium') || rise.includes('mid')){
        front_rise = 28, back_rise = 41;
      }else if (rise.includes('low')){
        front_rise = 27, back_rise = 40;
      }
    } else if(height == 'normal'){
      if(rise.includes('high')){
        front_rise = 32, back_rise = 44.5;
      }else if (rise.includes('medium') || rise.includes('mid')){
        front_rise = 29, back_rise = 42;
      }else if (rise.includes('low')){
        front_rise = 27, back_rise = 40;
      }
    } else if(height == 'tall'){
      if(rise.includes('high')){
        front_rise = 33, back_rise = 44.5;
      }else if (rise.includes('medium') || rise.includes('mid')){
        front_rise = 30, back_rise = 42;
      }else if (rise.includes('low')){
        front_rise = 28, back_rise = 40;
      }
    }
    return { front_rise, back_rise };
  }

  
  // Calculate measurements based on chest and height category for SHIRT (base measurement)
  async function bodyToGarmentShirtConvertor(parentWrapper, bodyTab, fitPreferenceTab, suggestedMeasurementsTab, measureUnit, url) {
    let chest;
    let userSize = {
      height: measureUnit 
        ? convertTo(parseFloat(bodyTab.find('.outer_box input.height').val().trim()), '') 
        : parseFloat(bodyTab.find('.outer_box input.height').val().trim()),

      neck: measureUnit 
        ? convertTo(parseFloat(bodyTab.find('.outer_box input.neck').val().trim()), '') 
        : parseFloat(bodyTab.find('.outer_box input.neck').val().trim()),

      chest: measureUnit 
        ? convertTo(parseFloat(bodyTab.find('.outer_box input.chest').val().trim()), '') 
        : parseFloat(bodyTab.find('.outer_box input.chest').val().trim()),

      shoulder: measureUnit 
        ? convertTo(parseFloat(bodyTab.find('.outer_box input.shoulders').val()), '') 
        : parseFloat(bodyTab.find('.outer_box input.shoulders').val().trim()),
    
      upperWaist: measureUnit 
        ? convertTo(parseFloat(bodyTab.find('.outer_box input.upper_waist').val()), '') 
        : parseFloat(bodyTab.find('.outer_box input.upper_waist').val().trim()),
    
      hip: measureUnit 
        ? convertTo(parseFloat(bodyTab.find('.outer_box input.hip').val()), '') 
        : parseFloat(bodyTab.find('.outer_box input.hip').val().trim()),
    
      biceps: measureUnit 
        ? convertTo(parseFloat(bodyTab.find('.outer_box input.biceps').val()), '') 
        : parseFloat(bodyTab.find('.outer_box input.biceps').val().trim()),

      arm_length: measureUnit 
        ? convertTo(parseFloat(bodyTab.find('.outer_box input.arm_length').val()), '') 
        : parseFloat(bodyTab.find('.outer_box input.arm_length').val().trim()),
    
      wrist: measureUnit 
        ? convertTo(parseFloat(bodyTab.find('.outer_box input.wrist').val()), '') 
        : parseFloat(bodyTab.find('.outer_box input.wrist').val()),

      chestType: bodyTab.find('select.sz-ppt-dropdwn-ele.chest_type').val(),
      stomachType: bodyTab.find('select.sz-ppt-dropdwn-ele.stomach_type').val(),
      fitPreference: fitPreferenceTab.find('.preference_active').attr('data-title').toLowerCase().replace(" ", "-") || 'tailored-fit',
      measureUnit: measureUnit ? 'inch' : 'cm',
      url: url
    }

    chest = parseFloat(userSize.chest) + 15;
    if(url) {
      recomendedSizes = await findNearestSize(chest, '', 2, url, '', 'shirt');
    }
    
    if(recomendedSizes){
      measureObj.push(recomendedSizes);
      $("#suggestedMeasurements .sz-ppt-size-actions").find(".sz-ppt-error-msg").remove();
      let shirtBodyMeasurements = await calculateShirtBaseMeasurements(chest, '', recomendedSizes, userSize);
      let measurements = await calculateShirtAdvMeasurements(userSize, bodyTab);

      if(measurements){
        setSuggestedMeasureTab(measurements, suggestedMeasurementsTab, parentWrapper, recomendedSizes);
      }
    }else{
      baseSizeNotFound('chest');
    }
  }
  
  async function calculateShirtBaseMeasurements(chest, heightCategory, recomendedSizes, userSize){
    finalMeasure = [];
    finalMeasure.push({
      'base_size': recomendedSizes.size,
      'unit': userSize.measureUnit,
      'height': parseFloat(userSize.height),
      'collar': getCollarMeasurement(userSize.neck, recomendedSizes.collar),
      'chest': chest,
      'shoulders': getShoulderMeasurement(userSize.shoulder, recomendedSizes.shoulders, 1.5, 4, 4)
    });
    let { upperWaist, newChest } = getUpperWaistMeasurement (chest, userSize, 'shirt');

    finalMeasure[0]['upper_waist'] = upperWaist;
    if(newChest){
      recomendedSizes = await findNearestSize(newChest, '', 2, userSize.url, '', 'shirt');
      if(recomendedSizes){
        finalMeasure[0]['base_size'] = recomendedSizes.size;
        finalMeasure[0]['collar'] = getCollarMeasurement(userSize.neck, recomendedSizes.collar);
        finalMeasure[0]['shoulders'] = getShoulderMeasurement(userSize.shoulder, recomendedSizes.shoulders, 1.5, 4, 4);
      }
      finalMeasure[0]['chest'] = newChest;
    }
    finalMeasure[0]['hip'] = upperWaist + 8;
    finalMeasure[0]['back_length'] = parseFloat(recomendedSizes.back_length) * 1;
    finalMeasure[0]['sleeve_length_left'] = Number(userSize.arm_length) + 2;
    finalMeasure[0]['sleeve_length_right'] = Number(userSize.arm_length) + 2;
    finalMeasure[0]['biceps'] = userSize.biceps > 40 ? parseFloat(recomendedSizes.biceps) + 2 : parseFloat(recomendedSizes.biceps);
    finalMeasure[0]['forearm'] = userSize.biceps > 40 ? parseFloat(recomendedSizes.forearm) + 2 : parseFloat(recomendedSizes.forearm);
    
    let arrSize1 = ['37 (US)', '37 (EU)', '38 (EU)', '39 (EU)', '40 (EU)'];
    let arrSize2 = ['41 (EU)', '42 (EU)', '43 (EU)', '44 (EU)', '45 (EU)'];
    let baseSizeLast = finalMeasure[0]['base_size'].split(" / ")[1];

    if(arrSize1.includes(baseSizeLast)){
      finalMeasure[0]['cuff_width_right'] = parseFloat(userSize.wrist) + 5.5;
      finalMeasure[0]['cuff_width_left'] = parseFloat(userSize.wrist) + 5.5;
    }else if(arrSize2.includes(baseSizeLast)){
      finalMeasure[0]['cuff_width_right'] = parseFloat(userSize.wrist) + 6.5;
      finalMeasure[0]['cuff_width_left'] = parseFloat(userSize.wrist) + 6.5;
    }
    //finalMeasure[0]['cuff_width_right'] = parseFloat(recomendedSizes.cuff_width_right) + 3;
    //finalMeasure[0]['cuff_width_left'] = parseFloat(recomendedSizes.cuff_width_left) + 3;
    //finalMeasure[0]['wrist'] = userSize.wrist;
    return finalMeasure;
  }

  async function calculateShirtAdvMeasurements(userSize, bodyTab){
    let chestType = userSize.chestType.toLowerCase();
    let stomachType = userSize.stomachType.toLowerCase();
    let fitPref = userSize.fitPreference.toLowerCase();

    bodyTab.find(".sz-ppt-dropdwn-ele").each(function() {
      let name = $(this).attr("name");
      let value = $(this).val();
      if(!$(this).hasClass("hide")){
        finalMeasure[0][name] = value;
      }
    });
    
    if(chestType == 'muscular'){
      finalMeasure[0]['chest'] = finalMeasure[0]['chest'] + 2;
    }
    if(stomachType == 'round stomach'){
      finalMeasure[0]['upper_waist'] = finalMeasure[0]['upper_waist'] + 2;
    }

    if(fitPref.includes('casual')){
      finalMeasure[0]['upper_waist'] = finalMeasure[0]['upper_waist'] + 4;
      finalMeasure[0]['hip'] = finalMeasure[0]['hip'] + 4;
      finalMeasure[0]['biceps'] = finalMeasure[0]['biceps'] + 2;
      finalMeasure[0]['forearm'] = finalMeasure[0]['forearm'] + 3;
      //finalMeasure[0]['wrist'] = finalMeasure[0]['wrist'] + 3;
    }

    finalMeasure[0]['chest_type'] = userSize.chestType;
    finalMeasure[0]['stomach_type'] = userSize.stomachType;
    finalMeasure[0]['fit_preference'] = fitPref;
    return finalMeasure;
  }

  function getCollarMeasurement(userNeck, recomendedCollar) {
    userNeck = parseFloat(userNeck);
    let userNeckNew = userNeck + 1.5
    if(userNeckNew < parseFloat(recomendedCollar)-4){
      userNeckNew = parseFloat(recomendedCollar)-4;
    }else if (userNeckNew > parseFloat(recomendedCollar)+4){
      userNeckNew = parseFloat(recomendedCollar)+4;
    }
    return userNeckNew;
  }


  // Calculate measurements based on chest and height category for WAISTCOAT (base measurement)
  async function bodyToGarmentWaistcoatConvertor(parentWrapper, bodyTab, fitPreferenceTab, suggestedMeasurementsTab, measureUnit, url) {
    let chest;
    let userSize = {
      height: measureUnit ? (bodyTab.find('.height_fit').length > 0 ? feetInchesToCm(bodyTab.find('.height_fit').val(), bodyTab.find('.height_inch').val())
        : convertTo(parseFloat(bodyTab.find('.outer_box input.height').val().trim()), ''))
      : parseFloat(bodyTab.find('.outer_box input.height').val().trim()),
    
      chest: measureUnit 
        ? convertTo(parseFloat(bodyTab.find('.outer_box input.chest').val().trim()), '') 
        : parseFloat(bodyTab.find('.outer_box input.chest').val().trim()),
    
      upperWaist: measureUnit 
        ? convertTo(parseFloat(bodyTab.find('.outer_box input.upper_waist').val()), '') 
        : parseFloat(bodyTab.find('.outer_box input.upper_waist').val().trim()),
    
      hip: measureUnit 
        ? convertTo(parseFloat(bodyTab.find('.outer_box input.hip').val()), '') 
        : parseFloat(bodyTab.find('.outer_box input.hip').val().trim()),
    
      backLength: measureUnit 
        ? convertTo(parseFloat(bodyTab.find('.outer_box input.back_length').val()), '') 
        : parseFloat(bodyTab.find('.outer_box input.back_length').val().trim()),
    
      chestType: bodyTab.find('select.sz-ppt-dropdwn-ele.chest_type').val(),
      stomachType: bodyTab.find('select.sz-ppt-dropdwn-ele.stomach_type').val(),
      measureUnit: measureUnit ? 'inch' : 'cm',
      url: url
    };

    let heightCategory = getHeightCategory(userSize.height, 'waistcoat');
    chest = parseFloat(userSize.chest) + 6;

    if(url) {
      recomendedSizes = await findNearestSize(chest, heightCategory, 1, url, 'chest', 'waistcoat');
    }

    if(recomendedSizes){
      measureObj.push(recomendedSizes);
      $("#suggestedMeasurements .sz-ppt-size-actions").find(".sz-ppt-error-msg").remove();
      let bodyMeasurements = await calculateWaistcoatBaseMeasurements(chest, heightCategory, recomendedSizes, userSize);
      let measurements = await calcWaistcoatAdvMeasurements(userSize, bodyTab);
      if(measurements){
        setSuggestedMeasureTab(measurements, suggestedMeasurementsTab, parentWrapper, recomendedSizes);
      }
    }else {
      baseSizeNotFound('chest');
    }
  }

  async function calculateWaistcoatBaseMeasurements(chest, heightCategory, recomendedSizes, userSize) {
    finalMeasure = [];
    finalMeasure.push({
      'base_size': recomendedSizes.size,
      'unit': userSize.measureUnit,
      'height': parseFloat(userSize.height),
      'chest': chest,
      'upper_waist': checkLimit(userSize.upperWaist, recomendedSizes.upper_waist, 6, 10, 10),
      'hip': checkLimit(userSize.hip, recomendedSizes.hip, 6, 10, 10),
      'back_length': userSize.backLength
    });
    return finalMeasure;
  }

  async function calcWaistcoatAdvMeasurements(userSize, bodyTab){
    let chestType = userSize.chestType.toLowerCase();
    let stomachType = userSize.stomachType.toLowerCase();

    bodyTab.find(".sz-ppt-dropdwn-ele").each(function() {
      let name = $(this).attr("name");
      let value = $(this).val();
      if(!$(this).hasClass("hide")){
        finalMeasure[0][name] = value;
      }
    });
    
    if(chestType == 'muscular'){
      finalMeasure[0]['chest'] = finalMeasure[0]['chest'] + 2;
    }
    if(stomachType == 'round stomach'){
      finalMeasure[0]['upper_waist'] = finalMeasure[0]['upper_waist'] + 2;
    }
    return finalMeasure;
  }


  // Calculate measurements based on chest and height category for RAGLAN COAT (base measurement)
  async function bodyToGarmentRaglanCoatConvertor(parentWrapper, bodyTab, fitPreferenceTab, suggestedMeasurementsTab, measureUnit, url) {
    let chest;
    let userSize = {
      height: measureUnit ? (bodyTab.find('.height_fit').length > 0 ? feetInchesToCm(bodyTab.find('.height_fit').val(), bodyTab.find('.height_inch').val())
        : convertTo(parseFloat(bodyTab.find('.outer_box input.height').val().trim()), ''))
      : parseFloat(bodyTab.find('.outer_box input.height').val().trim()),
    
      chest: measureUnit 
        ? convertTo(parseFloat(bodyTab.find('.outer_box input.chest').val().trim()), '') 
        : parseFloat(bodyTab.find('.outer_box input.chest').val().trim()),
    
      upperWaist: measureUnit 
        ? convertTo(parseFloat(bodyTab.find('.outer_box input.upper_waist').val()), '') 
        : parseFloat(bodyTab.find('.outer_box input.upper_waist').val().trim()),
    
      hip: measureUnit 
        ? convertTo(parseFloat(bodyTab.find('.outer_box input.hip').val()), '') 
        : parseFloat(bodyTab.find('.outer_box input.hip').val().trim()),
    
      biceps: measureUnit 
        ? convertTo(parseFloat(bodyTab.find('.outer_box input.biceps').val()), '') 
        : parseFloat(bodyTab.find('.outer_box input.biceps').val().trim()),
    
      armLength: measureUnit 
        ? convertTo(parseFloat(bodyTab.find('.outer_box input.arm_length').val()), '') 
        : parseFloat(bodyTab.find('.outer_box input.arm_length').val().trim()),
    
      chestType: bodyTab.find('select.sz-ppt-dropdwn-ele.chest_type').val(),
      stomachType: bodyTab.find('select.sz-ppt-dropdwn-ele.stomach_type').val(),
      fitPreference: fitPreferenceTab.find('.preference_active').attr('data-title').toLowerCase().replace(" ", "-") || 'casual-fit',
      raglanCoatLength: fitPreferenceTab.find('select.sz-ppt-dropdwn-ele.coat_length').val(),
      measureUnit: measureUnit ? 'inch' : 'cm',
      url: url
    };

    let heightCategory = getHeightCategory(userSize.height, 'raglan-coat');
    chest = getChestMeasurement(parseFloat(userSize.chest), heightCategory, 'raglan-coat');

    if(url) {
      recomendedSizes = await findNearestSize(chest, heightCategory, 3, url, 'chest', 'raglan-coat');
    }

    if(recomendedSizes){
      measureObj.push(recomendedSizes);
      $("#suggestedMeasurements .sz-ppt-size-actions").find(".sz-ppt-error-msg").remove();
      let bodyMeasurements = await calculateRaglanCoatBaseMeasurements(chest, heightCategory, recomendedSizes, userSize);
      let measurements = await calcRaglanCoatAdvMeasurements(userSize, bodyTab);
      
      if(measurements){
        setSuggestedMeasureTab(measurements, suggestedMeasurementsTab, parentWrapper, recomendedSizes);
      }
    }else {
      baseSizeNotFound('chest');
    }
  }

  async function calculateRaglanCoatBaseMeasurements(chest, heightCategory, recomendedSizes, userSize) {
    finalMeasure = [];
    finalMeasure.push({
      'base_size': recomendedSizes.size,
      'unit': userSize.measureUnit,
      'height': parseFloat(userSize.height),
      'chest': chest
    });
    let { upperWaist, newChest } = getCoatUpperWaistMeasurement (chest, userSize, 'raglan-coat');
  
    finalMeasure[0]['upper_waist'] = upperWaist;
    if(newChest){
      recomendedSizes = await findNearestSize(newChest, heightCategory, 3, userSize.url, '', 'raglan-coat');
      if(recomendedSizes){
        finalMeasure[0]['base_size'] = recomendedSizes.size;
      }
      finalMeasure[0]['chest'] = newChest;
    }

    finalMeasure[0]['hip'] = parseFloat(userSize.hip) + 12;
    if(finalMeasure[0]['hip'] < finalMeasure[0]['upper_waist']) {
      finalMeasure[0]['hip'] = parseFloat(recomendedSizes.hip) - 3;
    }

    finalMeasure[0]['biceps'] = userSize.biceps > 40 ? parseFloat(recomendedSizes.biceps) + 1.5 : parseFloat(recomendedSizes.biceps);
    finalMeasure[0]['back_length'] = parseFloat(recomendedSizes.back_length) * 1;
    finalMeasure[0]['sleeve_opening'] = userSize.biceps > 40 ? parseFloat(recomendedSizes.sleeve_opening) + 1 : parseFloat(recomendedSizes.sleeve_opening);
    finalMeasure[0]['sleeve_length_left'] = checkLimit(userSize.armLength + 4, parseFloat(recomendedSizes.sleeve_length_left), 10, 10);
    finalMeasure[0]['sleeve_length_right'] = checkLimit(userSize.armLength + 4, parseFloat(recomendedSizes.sleeve_length_right), 10, 10);
    return finalMeasure;
  }

  async function calcRaglanCoatAdvMeasurements(userSize, bodyTab){
    let chestType = userSize.chestType.toLowerCase();
    let stomachType = userSize.stomachType.toLowerCase();
    let fitPref = userSize.fitPreference.toLowerCase();
    let raglanCoatLength = userSize.raglanCoatLength.toLowerCase();

    bodyTab.find(".sz-ppt-dropdwn-ele").each(function() {
      let name = $(this).attr("name");
      let value = $(this).val();
      if(!$(this).hasClass("hide")){
        finalMeasure[0][name] = value;
      }
    });
    
    if(chestType == 'muscular'){
      finalMeasure[0]['chest'] = finalMeasure[0]['chest'] + 2;
    }
    if(stomachType == 'round stomach'){
      finalMeasure[0]['upper_waist'] = finalMeasure[0]['upper_waist'] + 2;
    }

    if(raglanCoatLength.includes('longer')){
      finalMeasure[0]['back_length'] = finalMeasure[0]['back_length'] + 5;
    }else if(raglanCoatLength.includes('shorter')){
      finalMeasure[0]['back_length'] = finalMeasure[0]['back_length'] - 5;
    }

    finalMeasure[0]['chest_type'] = userSize.chestType;
    finalMeasure[0]['stomach_type'] = userSize.stomachType;
    finalMeasure[0]['fit_preference'] = fitPref;
    finalMeasure[0]['coat_length'] = userSize.raglanCoatLength;
    return finalMeasure;
  }


  // Calculate measurements based on chest and height category for OVERCOAT (base measurement)
  async function bodyToGarmentOvercoatConvertor(parentWrapper, bodyTab, fitPreferenceTab, suggestedMeasurementsTab, measureUnit, url) {
    let chest;
    let userSize = {
      height: measureUnit ? (bodyTab.find('.height_fit').length > 0 ? feetInchesToCm(bodyTab.find('.height_fit').val(), bodyTab.find('.height_inch').val())
        : convertTo(parseFloat(bodyTab.find('.outer_box input.height').val().trim()), ''))
      : parseFloat(bodyTab.find('.outer_box input.height').val().trim()),
    
      chest: measureUnit 
        ? convertTo(parseFloat(bodyTab.find('.outer_box input.chest').val().trim()), '') 
        : parseFloat(bodyTab.find('.outer_box input.chest').val().trim()),

      shoulder: measureUnit 
        ? convertTo(parseFloat(bodyTab.find('.outer_box input.shoulders').val()), '') 
        : parseFloat(bodyTab.find('.outer_box input.shoulders').val().trim()),
    
      upperWaist: measureUnit 
        ? convertTo(parseFloat(bodyTab.find('.outer_box input.upper_waist').val()), '') 
        : parseFloat(bodyTab.find('.outer_box input.upper_waist').val().trim()),
    
      hip: measureUnit 
        ? convertTo(parseFloat(bodyTab.find('.outer_box input.hip').val()), '') 
        : parseFloat(bodyTab.find('.outer_box input.hip').val().trim()),
    
      biceps: measureUnit 
        ? convertTo(parseFloat(bodyTab.find('.outer_box input.biceps').val()), '') 
        : parseFloat(bodyTab.find('.outer_box input.biceps').val().trim()),
    
      armLength: measureUnit 
        ? convertTo(parseFloat(bodyTab.find('.outer_box input.arm_length').val()), '') 
        : parseFloat(bodyTab.find('.outer_box input.arm_length').val().trim()),
    
      chestType: bodyTab.find('select.sz-ppt-dropdwn-ele.chest_type').val(),
      stomachType: bodyTab.find('select.sz-ppt-dropdwn-ele.stomach_type').val(),
      fitPreference: fitPreferenceTab.find('.preference_active').attr('data-title').toLowerCase().replace(" ", "-") || 'tailored-fit',
      overcoatLength: fitPreferenceTab.find('select.sz-ppt-dropdwn-ele.coat_length').val(),
      measureUnit: measureUnit ? 'inch' : 'cm',
      url: url
    };

    let heightCategory = getHeightCategory(userSize.height, 'overcoat');
    chest = getChestMeasurement(parseFloat(userSize.chest), heightCategory, 'overcoat');

    if(url) {
      recomendedSizes = await findNearestSize(chest, heightCategory, 3, url, 'chest', 'overcoat');
    }

    if(recomendedSizes){
      measureObj.push(recomendedSizes);
      $("#suggestedMeasurements .sz-ppt-size-actions").find(".sz-ppt-error-msg").remove();
      let bodyMeasurements = await calculateOvercoatBaseMeasurements(chest, heightCategory, recomendedSizes, userSize);
      let measurements = await calcOvercoatAdvMeasurements(userSize, bodyTab);
      
      if(measurements){
        setSuggestedMeasureTab(measurements, suggestedMeasurementsTab, parentWrapper, recomendedSizes);
      }
    }else {
      baseSizeNotFound('chest');
    }
  }

  async function calculateOvercoatBaseMeasurements(chest, heightCategory, recomendedSizes, userSize) {
    finalMeasure = [];
    finalMeasure.push({
      'base_size': recomendedSizes.size,
      'unit': userSize.measureUnit,
      'height': parseFloat(userSize.height),
      'chest': chest,
      'shoulders': getShoulderMeasurement(userSize.shoulder, recomendedSizes.shoulders, 2, 4, 4)
    });

    let { upperWaist, newChest } = getCoatUpperWaistMeasurement (chest, userSize, 'overcoat');
  
    finalMeasure[0]['upper_waist'] = upperWaist;
    if(newChest){
      recomendedSizes = await findNearestSize(newChest, heightCategory, 3, userSize.url, '', 'overcoat');
      if(recomendedSizes){
        finalMeasure[0]['shoulders'] = getShoulderMeasurement(userSize.shoulder, recomendedSizes.shoulders, 2, 4, 4);
        finalMeasure[0]['base_size'] = recomendedSizes.size;
      }
      finalMeasure[0]['chest'] = newChest;
    }

    finalMeasure[0]['hip'] = parseFloat(userSize.hip) + 12;
    if(finalMeasure[0]['hip'] < finalMeasure[0]['upper_waist']) {
      finalMeasure[0]['hip'] = parseFloat(recomendedSizes.hip) - 3;
    }

    finalMeasure[0]['biceps'] = userSize.biceps > 40 ? parseFloat(recomendedSizes.biceps) + 1.5 : parseFloat(recomendedSizes.biceps);
    finalMeasure[0]['back_length'] = parseFloat(recomendedSizes.back_length) * 1;
    finalMeasure[0]['sleeve_opening'] = userSize.biceps > 40 ? parseFloat(recomendedSizes.sleeve_opening) + 1 : parseFloat(recomendedSizes.sleeve_opening);
    finalMeasure[0]['sleeve_length_left'] = checkLimit(userSize.armLength + 4, parseFloat(recomendedSizes.sleeve_length_left), 10, 10);
    finalMeasure[0]['sleeve_length_right'] = checkLimit(userSize.armLength + 4, parseFloat(recomendedSizes.sleeve_length_left), 10, 10);
    return finalMeasure;
  }

  async function calcOvercoatAdvMeasurements(userSize, bodyTab){
    let chestType = userSize.chestType.toLowerCase();
    let stomachType = userSize.stomachType.toLowerCase();
    let fitPref = userSize.fitPreference.toLowerCase();
    let overcoatLength = userSize.overcoatLength.toLowerCase();

    bodyTab.find(".sz-ppt-dropdwn-ele").each(function() {
      let name = $(this).attr("name");
      let value = $(this).val();
      if(!$(this).hasClass("hide")){
        finalMeasure[0][name] = value;
      }
    });
    
    if(chestType == 'muscular'){
      finalMeasure[0]['chest'] = finalMeasure[0]['chest'] + 2;
    }
    if(stomachType == 'round stomach'){
      finalMeasure[0]['upper_waist'] = finalMeasure[0]['upper_waist'] + 2;
    }

    if(fitPref.includes('casual')){
      finalMeasure[0]['upper_waist'] = finalMeasure[0]['chest'] - 2;
      finalMeasure[0]['hip'] = finalMeasure[0]['chest'] - 2;
      finalMeasure[0]['chest'] = finalMeasure[0]['chest'] + 6;
      finalMeasure[0]['shoulders'] = finalMeasure[0]['shoulders'] + 3;
      finalMeasure[0]['biceps'] = finalMeasure[0]['biceps'] + 2;
      finalMeasure[0]['sleeve_opening'] = finalMeasure[0]['sleeve_opening'] + 5;
    }

    //finalMeasure[0]['chest'] = checkLimit(finalMeasure[0]['chest'], recomendedSizes.chest, 3, 3);

    if(overcoatLength.includes('longer')){
      finalMeasure[0]['back_length'] = finalMeasure[0]['back_length'] + 5;
    }else if(overcoatLength.includes('shorter')){
      finalMeasure[0]['back_length'] = finalMeasure[0]['back_length'] - 5;
    }

    finalMeasure[0]['chest_type'] = userSize.chestType;
    finalMeasure[0]['stomach_type'] = userSize.stomachType;
    finalMeasure[0]['fit_preference'] = fitPref;
    finalMeasure[0]['coat_length'] = userSize.overcoatLength;
    return finalMeasure;
  }

  // Set suggested measurement tab based on algoright (For body measurement only)
  function setSuggestedMeasureTab(measureArray, tab, thisObj, recomendedArray) {
    measureArray = measureArray[0];
    if(tab){
      tab.find(".sz-ppt-size-actions .select-size-btn").addClass("isSelect").text(measureArray.base_size);
      if(measureArray.fit_preference_rise && measureArray.fit_preference_shape){
        let fitPref = measureArray.fit_preference_rise.replace('-', ' ') + ", " + measureArray.fit_preference_shape.replaceAll('-', ' ');
        tab.find(".sz-ppt-size-actions .fit-preference").addClass("isSelect").text(fitPref);
      }else{
        if(measureArray.fit_preference){
          tab.find(".sz-ppt-size-actions .fit-preference").addClass("isSelect").text(measureArray.fit_preference.replaceAll('-', ' '));
        }
      }
      
      selectedSize = measureArray.base_size;
      let currTabUnit = tab.find("input[type='checkbox']").prop("checked");

      if(measureArray.unit == 'inch'){
        tab.find("input[type='checkbox']").prop("checked", true);
      }else{
        tab.find("input[type='checkbox']").prop("checked", false);
      }

      /* WRITING THE VALUES OF DROPDOWN AND INPUT */
      let inputBoxes = tab.find('.sz-ppt-size-inptbx.outer_box .sz-ppt-size-input-ele');
      
      inputBoxes.each(function () {
        let inputEle = $(this);
        let inputName = inputEle.attr('name');
        let value = measureArray[inputName];

        inputEle.closest(".sz-ppt-size-inptbx").find('.sz-ppt-ip-right, .sz-ppt-ip-left').remove();
        
        if(inputEle.hasClass("sz-ppt-dropdwn-ele") && inputEle.find('option[value="standard"]').length > 0){
          inputEle.val("standard").trigger('change');
        }
        
        if (inputName && value !== undefined) {
          if (!inputEle.hasClass('sz-ppt-dropdwn-ele')) {
            let inputMin = inputEle.attr("min");
            let inputMax = inputEle.attr("max");

            let newvl = value;
            if(measureArray.unit == 'inch'){
              inputEle.val(convertTo(value, 'in'));
              inputEle.attr("data-value", convertTo(value, 'in'));
              newvl = convertTo(value, 'in');
            }else{
              inputEle.val(value);
              inputEle.attr("data-value", value);
            }

            /* Deviation calculation */
            let baseVal = Number(recomendedArray?.[inputName] ?? null);
            if(measureArray.unit == 'inch'){
              baseVal = convertTo(baseVal, 'in');
            }
            if(baseVal && !isNaN(baseVal)) {
              showDeviation(baseVal, newvl, measureArray.unit, inputEle.closest(".sz-ppt-size-inptbx"));
            }
            /* END Deviation calculation */

          } else {
            if (inputEle.find(`option[value="${value}"]`).length > 0){
              inputEle.val(value).trigger('change');
            }
          }
          inputEle.removeClass('err-msg-passport');
          $(this).parents('.sz-ppt-size-input').removeClass('opacity_cls');
        }
      });
      tab.parents(".sz-ppt-inside-container").find(".sz-ppt-footer .sz-ppt-next-btn.disabled").removeClass("disabled");
      findInsiders($('#suggestedMeasurements'));
    }
  }

  // Determine height category based on height
  function getHeightCategory(height, type) {
    const shortMin = type === 'jacket-body-next' ? 140 : 160;

    if (height >= shortMin && height <= 174) return "short";
    if (height >= 175 && height <= 186) return "normal";
    if (height >= 187) return "tall";
    return null;


    /*if (height >= 160 && height <= 174) return "short";
    if (height >= 175 && height <= 186) return "normal";
    if (height >= 187) return "tall";
    return null;*/
  }

  // Calculate chest measurement
  function getChestMeasurement(chest, heightCategory, type) {
    if(type == 'jacket') {
      if (heightCategory === "short") return chest + 10;
      else if (heightCategory === "normal" || heightCategory === "tall") return chest + 10;
      else return null;
    } else if(type == 'raglan-coat' || type == 'overcoat') {
      if (heightCategory === "short" || heightCategory === "normal" || heightCategory === "tall") return chest + 15;
      else return null;
    }
  }

  // Get back length value based on height for the jacket body measurement
  function getBackLengthBasedOnHeight(height) {
    const userHeight = Number(height);

    // Define the ranges and corresponding back lengths for each column
    const shortFitBackLength = [
      { min: 140, max: 160.5, length: 68 },
      { min: 160.6, max: 165.5, length: 69.5 },
      { min: 165.6, max: 170.5, length: 71 },
      { min: 170.6, max: 175.5, length: 73.5 },
      { min: 175.6, max: 180.5, length: 75 },
      { min: 180.6, max: 185.5, length: 76.5 },
      { min: 185.6, max: 190.5, length: 78 },
      { min: 190.6, max: 195.5, length: 79.5 },
      { min: 195.6, max: 200.5, length: 81 },
      { min: 200.6, max: 220.5, length: 82.5 }
    ];

    for (const range of shortFitBackLength) {
      if (userHeight >= range.min && userHeight <= range.max) {
        return range.length;
      }
    }
    return null; // invalid height
  }

  // Find base size from chest measurement (For the JACKET)
  async function findNearestJacketSize(targetVal, height, smallSizeLimitVal, URL) {
    let response = await fetch(URL);
    let resultData = await response.text();
    let sizeData = csvToArrayConverter(resultData);
    let nearestFlooring, jacketArr = [];
    const estimatedBackLength = getBackLengthBasedOnHeight(height);

    for(let i=0; i<sizeData.length; i++){
      if(sizeData[i]['size']){
        let lower = sizeData[i]['chest'];
        if(!sizeData[i + 1] || !sizeData[i + 1]['chest']) {
            continue; // Skip this iteration, move to next
        }
        let upper = sizeData[i + 1]['chest'];

        if (targetVal >= lower && targetVal <= upper) {
          let finalSize;
          const diff = targetVal - lower;
          nearestFlooring = diff <= smallSizeLimitVal ? sizeData[i] : sizeData[i + 1];
          jacketArr.push({
            'size': nearestFlooring['size'],
            'back_length': parseFloat(nearestFlooring['back length'])
          });
        }
      }
    }

    jacketArr = [...new Map(jacketArr.map(item => [item.size, item])).values()];

    // Find the nearest longest back length (>= estimatedBackLength)
    let nearestLongerBack = null;
    let smallestDiff = Infinity;

    for (const jacket of jacketArr) {
      const back = parseFloat(jacket['back_length']);
      const diff = back - estimatedBackLength;
      if (diff >= 0 && diff < smallestDiff) {
        smallestDiff = diff;
        nearestLongerBack = jacket;
      }
    }

    if(jacketArr.length == 0 && !nearestLongerBack) {
      return null;
    }

    if (!nearestLongerBack) {
      nearestLongerBack = jacketArr.reduce((best, curr) => {
        return parseFloat(curr['back_length']) > parseFloat(best['back_length']) ? curr : best;
      });
    }

    let finalSize = sizeData.filter(item => {
      return item.size == nearestLongerBack['size']
    });

    let nearestCeiling = finalSize[0];
    Object.keys(nearestCeiling).forEach((key) => {
      var replacedKey = key.trim().replaceAll(" ", "_").replaceAll("(", "").replaceAll(")", "");
      if (key !== replacedKey) {
        nearestCeiling[replacedKey] = nearestCeiling[key];
        delete nearestCeiling[key];
      }
    });
    return nearestCeiling;
  }

  // Find base size from chest measurement
  async function findNearestSize(targetVal, targetHeight, smallSizeLimitVal, URL, masterMeasure, type) {
    /*smallSizeLimitVal => 1 cm over smaller size (base size) = take smaller size, 2 cm (middle) = take smaller size, 3 cm over smaller size: take smaller size 
    If the chest measurement is an exact match with the measurement in the .csv file, select that one. If there's no exact match, choose the closest smaller chest measurement.
    Ex. chest = 111 so take base size with 110 chest (40R (US) / 50 (EU)) (bcz not exact match with 110 or 114)
    Ex. chest = 112 so take base size with 110 chest (40R (US) / 50 (EU)) (bcz not exact match with 110 or 114)
    Ex. chest = 113 so take base size with 110 chest (40R (US) / 50 (EU)) (bcz not exact match with 110 or 114)
    Ex. chest = 114 so take base size with 114 chest (42R (US) / 52 (EU)) (bcz exact match with 114 chest in .csv file) */
    masterMeasure = masterMeasure || 'chest';
    
    let response = await fetch(URL);
    let resultData = await response.text();
    let sizeData = csvToArrayConverter(resultData);
    let nearestCeiling;

    for(let i=0; i<sizeData.length; i++){
      if(sizeData[i]['size']){
        let lower = sizeData[i][masterMeasure];
        let upper = sizeData[i + 1][masterMeasure];

        if (targetVal >= lower && targetVal <= upper) {
          let finalSize;
          const diff = targetVal - lower;
          if (diff <= smallSizeLimitVal && diff > -1) {
            finalSize = sizeData[i]['size'];
          } else {
            finalSize = sizeData[i + 1]['size'];
          }

          if(type == 'trousers') {
            const sizeRangeByHeight = {
              short: { min: 22, max: 30 },
              normal: { min: 44, max: 60 },
              tall: { min: 86, max: 118 },
            };
            const currentRange = sizeRangeByHeight[targetHeight];
            const euMatch = sizeData[i]['size'].match(/\/\s*(\d+)\s*\(EU\)/);
            const euSize = parseInt(euMatch[1]);
            if(euSize >= currentRange.min && euSize <= currentRange.max) {
              nearestCeiling = diff <= smallSizeLimitVal ? sizeData[i] : sizeData[i + 1];
              break;
            }
          } else {
            if(finalSize.includes("S") || finalSize.includes("R") || finalSize.includes("L")){
              if(targetHeight == 'tall'){
                if(finalSize.includes("L")){
                  nearestCeiling = diff <= smallSizeLimitVal ? sizeData[i] : sizeData[i + 1];
                  break;
                }
              }else if(targetHeight == 'normal'){
                if(finalSize.includes("R")){
                  nearestCeiling = diff <= smallSizeLimitVal ? sizeData[i] : sizeData[i + 1];
                  break;
                }
              }else if(targetHeight == 'short'){
                if(finalSize.includes("S")){
                  nearestCeiling = diff <= smallSizeLimitVal ? sizeData[i] : sizeData[i + 1];
                  break;
                }
              }else{
                nearestCeiling = diff <= smallSizeLimitVal ? sizeData[i] : sizeData[i + 1];
                break;
              }
            }else{
              nearestCeiling = diff <= smallSizeLimitVal ? sizeData[i] : sizeData[i + 1];
              break;
            }
          }
        }
      }
    }

    let count = 0;
    let finalSz;
    if(nearestCeiling){
      if(type == 'shirt'){
        for(let j=0; j<sizeData.length; j++){
          if(sizeData[j][masterMeasure] == nearestCeiling[masterMeasure]){
            count+= 1;
            finalSz = sizeData[j];
          }
        }
    
        if(count > 1){
          nearestCeiling = finalSz;
        }
      }
    
      Object.keys(nearestCeiling).forEach((key) => {
        var replacedKey = key.trim().replaceAll(" ", "_").replaceAll("(", "").replaceAll(")", "");
        if (key !== replacedKey) {
          nearestCeiling[replacedKey] = nearestCeiling[key];
          delete nearestCeiling[key];
        }
      });
    }
    return nearestCeiling;
  }

  // Calculate shoulder measurement
  function getShoulderMeasurement (userShoulders, recomendedShoulder, addVal, minVal, maxVal){
    userShoulders = parseFloat(userShoulders);
    let userShouldersNew = userShoulders + addVal;
    if(userShoulders < parseFloat(recomendedShoulder) - minVal){
      userShouldersNew = parseFloat(recomendedShoulder) - minVal;
    }else if (userShoulders > parseFloat(recomendedShoulder) + maxVal){
      userShouldersNew = parseFloat(recomendedShoulder) + maxVal;
    }
    return userShouldersNew;
  }

  // Calculate upper waist measurement based on chest
  function getUpperWaistMeasurement (chest, userSize, type){
    let drop = parseFloat(userSize.chest) - parseFloat(userSize.upperWaist);
    let upperWaist;
    let newChest;
    if(type == 'jacket'){
      if(drop >= 16){
        upperWaist = chest - 12; //chest - 14
      }else if(drop >= 9 && drop < 16){
        upperWaist = chest - 9; //chest - 12
      }else if(drop >= 5 && drop < 9){
        upperWaist = chest - drop; //chest - drop
      }else if(drop <= 4){
        upperWaist = userSize.upperWaist + 5
        newChest = userSize.upperWaist + 5 + 4
      }
    }else if (type == 'shirt'){
      if(drop >= 5){
        upperWaist = chest - 9; //chest - 9
      }else if(drop <= 4){
        upperWaist = userSize.upperWaist + 5
        newChest = userSize.upperWaist + 5 + 4
      }
    }
    return { upperWaist, newChest };
  }

  // Calculate upper waist measurement based on chest for COAT
  function getCoatUpperWaistMeasurement (chest, userSize, type){
    let drop = parseFloat(userSize.chest) - parseFloat(userSize.upperWaist)
    let upperWaist;
    let newChest;
    if(drop >= 16){
      upperWaist = chest - 8;
    }else if(drop >= 6 && drop < 16){
      upperWaist = chest - 6;
    }else if(drop >= 4 && drop < 6){
      upperWaist = chest - drop;
    }else if(drop < 4){
      upperWaist = userSize.upperWaist + 8
      newChest = userSize.upperWaist + 11
    }
    return { upperWaist, newChest };
  }


  function checkLimit (userVal, recVal, minVal, maxVal){
    userVal = parseFloat(userVal);
    let userValNew = userVal;
    if(userVal < (parseFloat(recVal) - minVal)){
      userValNew = parseFloat(recVal) - minVal;
    }else if (userVal > (parseFloat(recVal) + maxVal)){
      userValNew = parseFloat(recVal) + maxVal;
    }
    return userValNew;
  }

  // Setup deviation value
  function showDeviation(bsVal, crVal, msrUnit, prntEle) {
    if(bsVal < crVal) {
      prntEle.append(`<p class="sz-ppt-ip-right">(+${Math.round((crVal - bsVal) * 100) / 100})</p>`);
    } else if(bsVal > crVal) {
      prntEle.append(`<p class="sz-ppt-ip-left">(-${Math.round((bsVal - crVal) * 100) / 100})</p>`);
    }
  }

  function convertTo(num, unit = 'cm'){
    if(unit == 'in')
      return (num / 2.54).toFixed(1); // Convert cm to inches, rounded to 1 decimal places    
    else
      return (num * 2.54).toFixed(1); // Convert inches to cm, rounded to 1 decimal places
  }

  function cmToFeetInches(cm) {
    let totalInches = parseFloat(cm / 2.54); // Convert cm to inches
    let feet = Math.floor(totalInches / 12.0); // Get whole feet
    let inches = parseFloat((totalInches % 12).toFixed(1)); // Get remaining inches

    return { feet, inches }; // Return an object
  }

  function feetInchesToCm(feet, inches) {
    feet = parseFloat(feet) || 0;   // Ensure feet is an integer
    inches = parseFloat(inches) || 0; // Ensure inches is an integer
    return ((feet * 30.48) + (inches * 2.54)).toFixed(1);
  }

  function feetInchesToInch (feet, inch) {
    // 1 foot = 12 inches, so we convert feet to inches and then add the additional inches
    return ((feet * 12) + inch);
  }

  // Show error when base size not found
  function baseSizeNotFound(type) {
    let $target = $("#suggestedMeasurements .sz-ppt-size-actions");
    if ($target.find(".sz-ppt-error-msg").length === 0) {
      $target.prepend("<span class='sz-ppt-msg sz-ppt-error-msg'>Base size not found. Please add the valid "+type+" measurement</span>");
    }
    $target[0].scrollIntoView({ behavior: 'smooth', block: 'center' });
  }
  
  
  // Convert CSV file data to Array
  function csvToArrayConverter(str, delimiter = ",") {
    const headers = str.slice(0, str.indexOf("\n")).split(delimiter);
    const rows = str.slice(str.indexOf("\n") + 1).split("\n");
  
    const arr = rows.map(function (row) {
      const values = row.split(delimiter);
      const el = headers.reduce(function (object, header, index) {
        object[header] = values[index];
        return object;
      }, {});
      return el;
    });
    return arr;
  }

  // Remove element from array
  function removeItem(array, item){
    for(var i in array){
      if(array[i]['uid']==item){
      array.splice(i,1);
        break;
      }
    }
  }

  // Tab click
  function findInsiders(elem) {
    var tabbable = elem.find('.outer_box input[type="number"].sz-ppt-size-input-ele:visible');
    if (tabbable.length === 0) return;
    tabbable.on('keydown', function (e) {
      if (e.key === 'Tab') {
        e.preventDefault();
        var currentIndex = tabbable.index(this);
        var nextIndex;
  
        if (e.shiftKey) {
          nextIndex = (currentIndex - 1 + tabbable.length) % tabbable.length;
        } else {
          nextIndex = (currentIndex + 1) % tabbable.length;
        }
        tabbable.eq(nextIndex).focus();
      }
    });
  };

  function findAdvInsiders(elem) {
    var tabbable = elem.find(".adv_opt .outer_box input[type='number'].sz-ppt-size-input-ele:visible");
    if (tabbable.length === 0) {
      console.warn('No tabbable inputs found');
      return;
    }
  
    tabbable.off('keydown').on('keydown', function (e) {
      if (e.key === 'Tab') {
        e.preventDefault();
        const currentIndex = tabbable.index(this);
        const nextIndex = e.shiftKey
          ? (currentIndex - 1 + tabbable.length) % tabbable.length
          : (currentIndex + 1) % tabbable.length;
  
        tabbable.eq(nextIndex).focus();
      }
    });
  }


  // Image upload (Only for staff members)
  if (document.getElementById('cm-upload-media')) {
    const dropzone = document.getElementById('cm-modifier-dropzone');
    const input = document.getElementById('cm-upload-media');
    const browseBtn = document.getElementById('cm-modifier-browse');
    const preview = document.querySelector('.cm-uploaded-media-preview');
    const previewFinal = document.querySelector('.cm-uploaded-media-preview-final');
    const MAX_FILES = 10;
    let uploadedFiles = [];

    if(document.querySelector(".cm-modifier-upload-media-bck-btn")){
      document.querySelector(".cm-modifier-upload-media-bck-btn").addEventListener("click", function() {
        this.closest(".sz-ppt-upload-media").classList.add("hide");
        this.closest(".isSelected").querySelector(".sz-ppt-middle").classList.remove("hide");
      });
    }

    // Browse click
    browseBtn.addEventListener('click', () => input.click());
    dropzone.addEventListener('click', (e) => {
      if (e.target !== browseBtn) input.click();
    });

    // Drag events
    dropzone.addEventListener('dragover', (e) => {
      e.preventDefault();
      dropzone.classList.add('dragover');
    });
    dropzone.addEventListener('dragleave', () => dropzone.classList.remove('dragover'));
    dropzone.addEventListener('drop', (e) => {
      e.preventDefault();
      dropzone.classList.remove('dragover');
      processFiles(Array.from(e.dataTransfer.files));
    });
    
    // Input change — use shared function
    input.addEventListener('change', function () {
      processFiles(Array.from(this.files));
      input.value = "";
    });

    // called by both input change and drag & drop
    function processFiles(files) {
      const remaining    = MAX_FILES - uploadedFiles.length;
      const invalidFiles = [];

      clearMessage();

      if (remaining <= 0) {
        showMessage(`You can upload a maximum of ${MAX_FILES} images.`, 'error');
        return;
      }

      const validFiles = files.filter((file) => {
        const { valid, reason } = validateFile(file);
        if (!valid) invalidFiles.push(reason);
        return valid;
      });

      if (invalidFiles.length > 0) {
        // showMessage(`The following files were rejected:<br>${invalidFiles.join('<br>')}`, 'error');
        showMessage(`${invalidFiles.join('<br>')}`, 'error');
      }

      if (validFiles.length === 0) return;

      var allowedFiles = validFiles.slice(0, remaining);
      if (validFiles.length > remaining) {
        showMessage(`You can only add ${remaining} image(s). Only first ${remaining} will be added.`, 'error');
      }

      allowedFiles.forEach((file) => {
        uploadedFiles.push(file);
        renderPreview(file, uploadedFiles.length - 1);
      });

      toggleUploadBtn();
    }

    // preview of selected images
    function renderPreview(file, index) {
      const reader = new FileReader();
      reader.onload = function (e) {
        const box = document.createElement('div');
        box.className = 'cm-preview-box';
        box.dataset.index = index;

        if (file.type.startsWith('video/')) {
          const video = document.createElement('video');
          video.src = e.target.result;
          video.controls = false;
          video.muted = true;
          video.playsInline = true;

          // Play on hover, pause on leave
          video.addEventListener('mouseenter', () => video.play());
          video.addEventListener('mouseleave', () => {
            video.pause();
            video.currentTime = 0;
          });
          box.appendChild(video);
        } else {
          const img = document.createElement('img');
          img.src = e.target.result;
          box.appendChild(img);
        }

        // Video badge
        if (file.type.startsWith('video/')) {
          const badge = document.createElement('span');
          badge.className = 'media-badge';
          badge.innerHTML = '▶';
          box.appendChild(badge);
        }

        const btn = document.createElement('button');
        btn.className = 'cm-modifier-remove-btn';
        btn.innerHTML = '×';

        btn.onclick = function () {
          const idx = parseInt(box.dataset.index);
          uploadedFiles.splice(idx, 1);
          box.remove();

          Array.from(preview.querySelectorAll('.cm-preview-box')).forEach((b, i) => {
            b.dataset.index = i;
          });

          syncInputFiles();
          toggleUploadBtn();
          if(uploadedFiles.length < 10) {
            clearMessage();
          }
        };

        box.appendChild(btn);
        preview.appendChild(box);
      };
      reader.readAsDataURL(file);
    }

    // preview of uploaded images
    function renderUploadedMediaPreview(file, index) {
      const reader = new FileReader();
      reader.onload = function (e) {
        const box = document.createElement('div');
        box.className = 'cm-preview-box';
        box.dataset.index = index;

        const img = document.createElement('img');
        img.src = e.target.result;
        box.appendChild(img);
        previewFinal.appendChild(box);
      };
      reader.readAsDataURL(file);
    }

    // Upload API Function
    async function uploadFiles() {
      if (uploadedFiles.length === 0) {
        showMessage('Please select at least one image.', 'error');
        return;
      }

      const formData = new FormData();
      uploadedFiles.forEach((file) => {
        formData.append('files[]', file);
      });

      const uploadBtn = document.getElementById('cm-upload-media-btn');
      let originalText;

      try {
        uploadBtn.disabled = true;
        originalText = uploadBtn.textContent;
        uploadBtn.textContent = 'Uploading...';

        const response = await fetch('/apps/GLM/upload-media', {
          method: 'POST',
          body: formData,
        });
        const result = await response.json();

        if (response.ok) {
          if(result.status == "success") {
            window.media = result.urls;
            showMessage(result.message, 'success');
            setTimeout(() => {
              clearMessage();
            }, 3000);
          } else {
            showMessage(result.message, 'error');
          }
          
          // Clear after successful upload
          previewFinal.innerHTML = '';
          previewFinal.innerHTML += '<p>Uploaded Media</p>';
          uploadedFiles.forEach((file) => {
            renderUploadedMediaPreview(file, uploadedFiles.length - 1);
          });
          
          uploadedFiles = [];
          preview.innerHTML = '';
          syncInputFiles();
          toggleUploadBtn();
        } else {
          showMessage(result.message, 'error');
          toggleUploadBtn();
        }

      } catch (error) {
        showMessage('Something went wrong. Please try again.', 'error');
        toggleUploadBtn();
      } finally {
        uploadBtn.textContent = originalText;
      }
      
    }

    // Bind upload button
    document.getElementById('cm-upload-media-btn').addEventListener('click', uploadFiles);

    function syncInputFiles() {
      const dt = new DataTransfer();
      uploadedFiles.forEach((file) => dt.items.add(file));
      input.files = dt.files;
    }

    // Toggle disabled on upload button
    function toggleUploadBtn() {
      const uploadBtn = document.getElementById('cm-upload-media-btn');
      if (!uploadBtn) return;
      uploadBtn.disabled = uploadedFiles.length === 0;
    }

    // Allowed extensions & mimes (matching backend)
    const ALLOWED_CONFIG = {
      extensions: ['jpg', 'jpeg', 'png', 'heic', 'heif', 'webp'],
      mimes: ['image/jpeg','image/png','image/heic','image/heif','image/heic-sequence','image/heif-sequence','image/webp']
    };

    function validateFile(file) {
      const ext = file.name.split('.').pop().toLowerCase();
      const mime = file.type.toLowerCase();

      const isExtValid  = ALLOWED_CONFIG.extensions.includes(ext);
      const isMimeValid = ALLOWED_CONFIG.mimes.includes(mime);
      const isHeic = ['heic', 'heif'].includes(ext) && mime === '';

      if (!isExtValid) {
        return { valid: false, reason: `"${file.name}" — .${ext} file not supported.` };
      }
      if (!isMimeValid && !isHeic) {
        return { valid: false, reason: `"${file.name}" — invalid media format (${mime || 'unknown'}).` };
      }
      return { valid: true };
    }

    window.showMessage = function(message, type = 'error') {
      const msg = document.querySelector('.cm-media-upload-msg');
      if (!msg) return;
      msg.innerHTML = message;
      msg.className = type === 'success' ? 'cm-media-upload-success cm-media-upload-msg' : 'cm-media-upload-error cm-media-upload-msg';
    }

    function clearMessage() {
      const msg = document.querySelector('.cm-media-upload-msg');
      if (!msg) return;
      msg.innerHTML = '';
      msg.classList.remove("cm-media-upload-success", "cm-media-upload-error");
    }
  }
});